var $DOCUMENT = window.document;

function MZIQ_StockInfo() {
    var self = this;

    self.rootElement = undefined;
    self.INDEXES = undefined;
    self.FILEMANAGER = undefined;
    self.EVENTS = undefined;
    self.ARROW_IMAGES = undefined;
    self.SHOW_VARIATION_ARROW = true;
    self.HAS_SHORT_MODE = false;
    self.IS_SIMPLE_CHART = undefined;
    self.HIGHSTOCK_OPTIONS = undefined;
    self.CHART_HEIGHT = undefined;
    self.CHART_COLORS = undefined;
    self.CHART_TYPE = undefined;
    self.CHART_PERIOD = "6m";
    self.CHART_STOCKS = undefined;
    self.SWITCH_TICKER_INDEX = undefined;
    self.END_DATE = moment();
    self.START_DATE = moment().subtract(1, "months");
    self.IS_INDEX = undefined;
    self.TICKER = undefined;
    self.CURRENCY_SYMBOL = undefined;
    self.DATEPICKER_DATE_FORMAT = undefined;
    self.DECIMAL_PLACES = 2;
    self.MOMENT_DATE_FORMAT = undefined;
    self.LANGUAGE = undefined;
    self.STOCK_ID = undefined;
    self.ADJUSTED = false;
    self.API_URL = "https://api.mziq.com/mzstockinfo";
    self.API_URL_FILES = "https://api.mziq.com/mzfilemanager";
    self.API_URL_EVENTS = "https://api.mziq.com/mzevents/events";

    self.initialize = function (options, el) {
        self.HAS_SHORT_MODE = options.shortMode ? options.shortMode : false;
        self.SHOW_VARIATION_ARROW = options.template.showVariationArrow === undefined ? true : options.template.showVariationArrow;
        self.ARROW_IMAGES = options.template.arrowImages === undefined ? undefined : options.template.arrowImages;
        self.DECIMAL_PLACES = options.decimalPlaces ? options.decimalPlaces : 2;
        self.INDEXES = options.indexes ? options.indexes : undefined;

        self.rootElement = $DOCUMENT.querySelector(el);

        var initializeTemplate = {
            raw: function () {
                stockinfoLive(options, options.rawInit);
            },
            live: function () {
                stockinfoLive(options, function (result) {
                    if (!result) {
                        console.error("Não foi possível recuperar os dados das cotações. Tente novamente ou contate o suporte!");
                    } else {
                        stockinfoRenderLive(result, options);
                    }
                });
            },
            chart: function () {
                stockinfoChart(options);
            },
            simpleChart: function () {
                stockinfoChart(options);
            },
            history: function () {
                stockinfoHistory(options);
            },
        };
        return initializeTemplate[options.template.type]();
    };

    function checkShortMode(conversion) {
        if (self.LANGUAGE === "pt") {
            return conversion.replace(".", ",");
        }
        return conversion;
    }

    function convertToShortMode(value) {
        if (value.toString().includes(".") === true) {
            var formattedValue = value.toString().replace(".", "");

            if (self.IS_INDEX === true) {
                value = parseInt(value.toString().replace(".", ""));
            }

            if (Number(formattedValue) > 1000) {
                value = formattedValue;
                value = Number(value);
            }
        }

        if (value >= 11000000000) {
            return checkShortMode((value / 10000000000).toFixed(1) + "T");
        }
        if (value >= 10000000000) {
            return checkShortMode((value / 10000000000).toFixed(0) + "T");
        }

        if (value >= 1100000000) {
            return checkShortMode((value / 1000000000).toFixed(1) + "B");
        }

        if (value >= 1000000000) {
            return checkShortMode((value / 1000000000).toFixed(0) + "B");
        }

        if (value >= 1100000) {
            return checkShortMode((value / 1000000).toFixed(1) + "M");
        }

        if (value >= 1000000) {
            return checkShortMode((value / 1000000).toFixed(0) + "M");
        }

        if (value >= 100000) {
            return checkShortMode((value / 1000).toFixed(0) + "K");
        }

        if (value >= 10000) {
            return checkShortMode((value / 1000).toFixed(0) + "K");
        }

        if (value >= 1100) {
            return checkShortMode((value / 1000).toFixed(1) + "K");
        }

        if (value >= 1000) {
            return checkShortMode((value / 1000).toFixed(0) + "K");
        }

        return checkShortMode(parseInt(value).toString());
    }

    function logErrorsInConsole(errors) {
        if (errors.length === 0) {
            return;
        }

        console.error("Stockinfo errors: ");
        for (var i = 0; i < errors.length; i++) {
            console.error(errors[i]);
        }
    }

    function formatCurrency(number, showCurrencySymbol, isIndex) {
        if (!number) return "-";

        var prefix = "";
        var result = undefined;
        var decimalConfig = { minimumFractionDigits: self.DECIMAL_PLACES, maximumFractionDigits: self.DECIMAL_PLACES };

        if (isIndex === true) {
            decimalConfig = {};
        }

        if (showCurrencySymbol && self.CURRENCY_SYMBOL && isIndex !== true) {
            prefix = self.CURRENCY_SYMBOL + " ";
        }

        switch (self.LANGUAGE) {
            case "pt":
                result = prefix + number.toLocaleString("pt-BR", decimalConfig);
                break;
            case "pt-br":
                result = prefix + number.toLocaleString("pt-BR", decimalConfig);
                break;
            case "es":
                result = prefix + number.toLocaleString("pt-BR", decimalConfig);
                break;
            case "es-es":
                result = prefix + number.toLocaleString("pt-BR", decimalConfig);
                break;
            case "zh-hant":
                result = prefix + number.toLocaleString("en-US", decimalConfig);
                break;
            case "zh-hans":
                result = prefix + number.toLocaleString("en-US", decimalConfig);
                break;
            case "fr":
                result = prefix + number.toLocaleString("en-US", decimalConfig);
                break;
            case "de":
                result = prefix + number.toLocaleString("en-US", decimalConfig);
                break;
            default:
                result = prefix + number.toLocaleString("en-US", decimalConfig);
                break;
        }

        return result;
    }

    function formatNumber(number, hasDecimal, isIndex) {
        if (!number) return "-";

        var decimalConfig = { minimumFractionDigits: self.DECIMAL_PLACES, maximumFractionDigits: self.DECIMAL_PLACES };

        if (self.IS_INDEX === true || isIndex === true || hasDecimal === false) {
            decimalConfig = {};
        }

        switch (self.LANGUAGE) {
            case "pt":
                return number.toLocaleString("pt-BR", decimalConfig);
            case "pt-br":
                return number.toLocaleString("pt-BR", decimalConfig);
            case "es":
                return number.toLocaleString("pt-BR", decimalConfig);
            case "es-es":
                return number.toLocaleString("pt-BR", decimalConfig);
            case "zh-hant":
                return number.toLocaleString("en-US", decimalConfig);
            case "zh-hans":
                return number.toLocaleString("en-US", decimalConfig);
            case "fr":
                return number.toLocaleString("en-US", decimalConfig);
            case "de":
                return number.toLocaleString("en-US", decimalConfig);
            default:
                return number.toLocaleString("en-US", decimalConfig);
        }
    }

    function formatDate(value, templateValue) {
        var shortMonths = [];
        var formatDay = moment.utc(value, "YYYY-MM-DD").format("DD");
        var formatMonth = moment.utc(value, "YYYY-MM-DD").format("M") - 1;
        var formatYear = moment.utc(value, "YYYY-MM-DD").format("YYYY");
        switch (self.LANGUAGE) {
            case "pt":
                shortMonths = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
                break;
            case "pt-br":
                shortMonths = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
                break;
            case "es":
                shortMonths = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
                break;
            case "es-es":
                shortMonths = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
                break;
            case "zh-hant":
                shortMonths = ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"];
                break;
            case "zh-hans":
                shortMonths = ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"];
                break;
            case "fr":
                shortMonths = ["Jan", "Fév", "Mar", "Avr", "Peu", "Jui", "Jui", "Aoû", "Sep", "Oct", "Nov", "Déc"];
                break;
            case "de":
                shortMonths = ["Jan", "Fév", "Mar", "Avr", "Peu", "Jui", "Jui", "Aoû", "Sep", "Oct", "Nov", "Déc"];
                break;
            default:
                shortMonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                break;
        }
        return templateValue.format(formatDay, shortMonths[formatMonth], formatYear);
    }

    function getLastUpdateDate(stocks) {
        var lastUpdateDate = undefined;

        stocks.map(function (stock) {
            var stockDate = moment(stock.info.date + " " + stock.info.time, "YYYY-MM-DD HH:mm:ss");
            if (!lastUpdateDate || stockDate.diff(lastUpdateDate, "minutes") > 0) {
                lastUpdateDate = stockDate;
            }
        });

        if (self.LANGUAGE === "pt" || self.LANGUAGE === "es" || self.LANGUAGE === "pt-br" || self.LANGUAGE === "es-es") {
            return lastUpdateDate.format("DD/MM/YY HH:mm");
        } else {
            return lastUpdateDate.format("MM/DD/YY hh:mm A");
        }
    }

    function stockinfoLive(params, callback) {
        loadLiveParams(params);
        loadLiveData(callback);
    }

    function loadLiveParams(params) {
        self.STOCK_ID = params.stockinfoId;
        self.LANGUAGE = params.language ? params.language : "pt";
        self.MOMENT_DATE_FORMAT = self.LANGUAGE === "pt" || self.LANGUAGE === "es" || self.LANGUAGE === "pt-br" || self.LANGUAGE === "es-es" ? "DD/MM/YYYY" : "MM/DD/YYYY";
        self.CURRENCY_SYMBOL = params.currencySymbol ? params.currencySymbol : "R$";
        self.DECIMAL_PLACES = params.decimalPlaces ? params.decimalPlaces : 2;
    }

    function loadLiveData(callback) {
        var apiUrl = self.API_URL + "/" + self.STOCK_ID + "/live";

        $.ajax({
            url: apiUrl,
            type: "GET",
            dataType: "json",
            success: function (result) {
                if (!result.data) {
                    return callback(null);
                }

                var hasData = result.data.tickers.length > 0 || result.data.indexes.length > 0;

                if (!hasData) {
                    logErrorsInConsole(result.data.errors);
                    return callback(null);
                }

                logErrorsInConsole(result.data.errors);
                return callback(result.data);
            },
            error: function (res) {
                console.error("Erro ao recuperar dados da API: ");
                console.error(res);
                return callback(null);
            },
        });
    }

    function renderHighlight(data, language) {
        var tickerInfo = data.tickers[0];

        var dirClass = tickerInfo.info.var > 0 ? "up" : "down";

        var variationText = {
            pt: "Variação:",
            en: "Variation:",
            es: "Variación:",
            "zh-hant": "變化:",
            "zh-hans": "变化:",
            fr: "Variation:",
            de: "Variation:",
        };

        var tickerText = {
            pt: "Ativo: ",
            en: "Asset: ",
            es: "Activo: ",
            "zh-hant": "積極的: ",
            "zh-hans": "积极的: ",
            fr: "Actif:",
            de: "Anlagegut:",
        };

        var highlightTemplate =
            '<div class="highlight ticker element-wrapper">' + '<span class="value">' + formatCurrency(tickerInfo.info.price, true) + "</span>" + '<div class="infos-wrapper">' + '<span class="ticker"><span class="pref ticker-name">' + tickerText[language] + " </span>" + tickerInfo.ticker + "</span>" + '<span class="variation ' + dirClass + '"><span class="pref variation-name">' + variationText[language] + " </span>" + formatNumber(tickerInfo.info.var, true) + "%</span>" + "</div>" + "</div>";

        $(self.rootElement).prepend(highlightTemplate);
        $("#stockinfo-live-table tbody tr:eq(0)").hide();
    }

    function stockinfoRenderLive(data, params) {
        var stocks = [];
        var table = $DOCUMENT.createElement("table");
        var header = undefined;

        [].push.apply(
            stocks,
            data.tickers.map(function (t) {
                t.isIndex = false;
                return t;
            })
        );

        [].push.apply(
            stocks,
            data.indexes.map(function (i) {
                i.isIndex = true;
                return i;
            })
        );

        table.setAttribute("id", "stockinfo-live-table");

        $(self.rootElement).append(table);

        switch (self.LANGUAGE) {
            case "pt":
                header = "<th class='ticker'>Asset</td>";
                break;
            case "pt-br":
                header = "<th class='ticker'>Asset</td>";
                break;
            case "es":
                header = "<th class='ticker'>Activo</td>";
                break;
            case "es-es":
                header = "<th class='ticker'>Activo</td>";
                break;
            case "zh-hant":
                header = "<th class='ticker'>積極的</td>";
                break;
            case "zh-hans":
                header = "<th class='ticker'>积极的</td>";
                break;
            case "fr":
                header = "<th class='ticker'>Actif</td>";
                break;
            case "de":
                header = "<th class='ticker'>Anlagegut</td>";
                break;
            default:
                header = "<th class='ticker'>Asset</td>";
                break;
        }

        $(table).append(showTableHeader(params));
        $(table).find("thead tr").prepend(header);

        var renderTickerPreffix = function () {
            if (!!params.template.preffix) {
                var hasTickerPreffix = params.template.preffix.filter(function (item) {
                    return item.field === "ticker";
                });

                if (hasTickerPreffix.length > 0) {
                    return hasTickerPreffix[0].symbol;
                } else {
                    return "";
                }
            } else {
                return "";
            }
        };

        var renderTickerSuffix = function () {
            if (!!params.template.suffix) {
                var hasTickerSuffix = params.template.suffix.filter(function (item) {
                    return item.field === "ticker";
                });

                if (hasTickerSuffix.length > 0) {
                    return hasTickerSuffix[0].symbol;
                } else {
                    return "";
                }
            } else {
                return "";
            }
        };

        stocks.map(function (stock) {
            // formatting goes here...

            var colorClass = "up";

            if (stock.info.var < 0) colorClass = "down";

            var price = stock.isIndex ? formatNumber(stock.info.price) : formatCurrency(stock.info.price, true);
            var variation = formatCurrency(stock.info.var, false);
            var volume = formatNumber(stock.info.vol);
            var itemTr = document.createElement("tr");

            $(table).append(itemTr);
            if (!!params.template.tickerLink && !!params.template.tickerLink[stock.ticker]) {
                $(itemTr).append('<td class="ticker"><a href="' + params.template.tickerLink[stock.ticker][self.LANGUAGE] + '" target="_blank">' + renderTickerPreffix() + stock.ticker + renderTickerSuffix() + "</a></td>");
            } else {
                $(itemTr).append('<td class="ticker">' + renderTickerPreffix() + stock.ticker + renderTickerSuffix() + "</td>");
            }

            Object.keys(stock.info).forEach(function (stockItem) {
                if (!!params.template.columns && !params.template.columns.includes(stockItem)) {
                    return false;
                }

                $(itemTr).append('<td class="' + renderClassName(stockItem, colorClass) + '">' + renderPreffix(params, stockItem) + renderItemValue(stockItem, stock.info[stockItem], colorClass, stock.isIndex) + renderSuffix(params, stockItem) + "</td>");
            });

            if (!!params.template.customArrow) {
                if (self.ARROW_IMAGES !== undefined) {
                    var imageUrl;

                    if (stock.info.var < 0) {
                        imageUrl = self.ARROW_IMAGES.down;
                    } else if (stock.info.var > 0) {
                        imageUrl = self.ARROW_IMAGES.up;
                    } else if (stock.info.var === 0) {
                        imageUrl = self.ARROW_IMAGES.neutral;
                    }

                    $(itemTr).append('<td class="arrow custom-arrow-td"><img class="custom-arrow-image" src="' + imageUrl + '"></img></td>');
                } else {
                    var customClass = stock.info.var < 0 ? "down" : "up";
                    $(itemTr).append('<td class="arrow custom-arrow-td"><span class="custom-arrow-default ' + customClass + '"></span></td>');
                }
            }
        });

        var hasLabelRender = function (parameter) {
            if (!!params.customLabels && !!params.customLabels[parameter]) {
                return params.customLabels[parameter];
            }
            return false;
        };

        var arrowLabel = hasLabelRender("arrow") !== false ? hasLabelRender("arrow") : "Arrow";

        if (!!params.template.customArrow) {
            $("th.arrow.custom-arrow").remove();
            $(table)
                .find("thead tr")
                .append('<th class="arrow custom-arrow">' + arrowLabel + "</th>");
        }

        if (params.highlight === true) {
            renderHighlight(data, params.language);
        }

        moveColumn(params);

        var lastUpdateDate = getLastUpdateDate(stocks);

        var sourceText = {
            pt: "Fonte: ",
            en: "Source: ",
            es: "Fuente: ",
            "zh-hant": "來源: ",
            "zh-hans": "来源: ",
            fr: "La source: ",
            de: "Quelle: ",
        };

        var delayText = {
            pt: " - Atraso de 15 min.",
            en: " - 15 min. delay",
            es: " - 15 min. de retraso",
            "zh-hant": " - 延遲15分鐘",
            "zh-hans": " - 延迟15分钟",
            fr: "15 minutes retard.",
            de: "15 Minuten verzögern.",
        };

        var footer = "<tr class='footer'>" + "<td colspan='4'>" + lastUpdateDate + delayText[self.LANGUAGE] + " | " + sourceText[self.LANGUAGE] + '<a href="' + data.link + '" target="_blank">' + data.source + "</a>";
        "</td>" + "</tr>";

        $(table).append(footer);
        renderLegends(params);
    }

    function stockinfoHistory(params) {
        loadHistoryParams(params);
        initSearchButton(params);
        initExportExcelButton();
        loadHistoryData(params);
        initDatePicker();

        var header = $("header");
        var script = document.createElement("script");

        var includeScript = {
            pt: function () {
                script.src = "https://s3.amazonaws.com/mz-prd-stockinfo/assets/js/datepicker/datepicker-pt-BR.js";
                document.head.appendChild(script);
            },
            "pt-br": function () {
                script.src = "https://s3.amazonaws.com/mz-prd-stockinfo/assets/js/datepicker/datepicker-pt-BR.js";
                document.head.appendChild(script);
            },
            es: function () {
                script.src = "https://s3.amazonaws.com/mz-prd-stockinfo/assets/js/datepicker/datepicker-es.js";
                document.head.appendChild(script);
            },
            "es-es": function () {
                script.src = "https://s3.amazonaws.com/mz-prd-stockinfo/assets/js/datepicker/datepicker-es.js";
                document.head.appendChild(script);
            },
            en: function () {
                script.src = "https://s3.amazonaws.com/mz-prd-stockinfo/assets/js/datepicker/datepicker-en-GB.js";
                document.head.appendChild(script);
            },
            "zh-hant": function () {
                script.src = "https://mz-prd-stockinfo.s3.amazonaws.com/assets/js/datepicker/datepicker-zh-TW.js";
                document.head.appendChild(script);
            },
            "zh-hans": function () {
                script.src = "https://mz-prd-stockinfo.s3.amazonaws.com/assets/js/datepicker/datepicker-zh-CN.js";
                document.head.appendChild(script);
            },
            fr: function () {
                script.src = "https://s3.amazonaws.com/mz-prd-stockinfo/assets/js/datepicker/datepicker-fr-FR.js";
                document.head.appendChild(script);
            },
            de: function () {
                script.src = "https://s3.amazonaws.com/mz-prd-stockinfo/assets/js/datepicker/datepicker-de-DE.js";
                document.head.appendChild(script);
            },
        };
        includeScript[params.language]();
    }

    function headerTemplate(options, params) {
        var strTemplate = "<thead>";

        Object.keys(options).forEach(function (item) {
            if (!!params.template.columns && !params.template.columns.includes(item)) {
                return false;
            }
            strTemplate += '<th class="' + options[item].className + '">' + options[item].label + "</th>";
        });

        strTemplate += "</thead>";

        return strTemplate;
    }

    function showTableHeader(params) {
        var hasLabel = function (parameter) {
            if (!!params.customLabels && !!params.customLabels[parameter]) {
                return params.customLabels[parameter];
            }
            return false;
        };

        var header = {
            pt: function () {
                var templatePT = {
                    date: {
                        label: hasLabel("date") !== false ? hasLabel("date") : "Data",
                        className: "date",
                    },
                    var: {
                        label: hasLabel("var") !== false ? hasLabel("var") : "Variação (%)",
                        className: "var variation",
                    },
                    high: {
                        label: hasLabel("high") !== false ? hasLabel("high") : "Máxima",
                        className: "max high",
                    },
                    low: {
                        label: hasLabel("low") !== false ? hasLabel("low") : "Mínima",
                        className: "min low",
                    },
                    open: {
                        label: hasLabel("open") !== false ? hasLabel("open") : "Aberto",
                        className: "open",
                    },
                    closed: {
                        label: hasLabel("closed") !== false ? hasLabel("closed") : "Fechado",
                        className: "closed",
                    },
                    middle: {
                        label: hasLabel("middle") !== false ? hasLabel("middle") : "Média",
                        className: "middle",
                    },
                    vol: {
                        label: hasLabel("vol") !== false ? hasLabel("vol") : "Volume",
                        className: "vol",
                    },
                    share: {
                        label: hasLabel("share") !== false ? hasLabel("share") : "Quantidade",
                        className: "share",
                    },
                    trade: {
                        label: hasLabel("trade") !== false ? hasLabel("trade") : "Negócios",
                        className: "trade",
                    },
                };

                if (params.template.type === "live") {
                    var liveObj = {
                        marketCap: {
                            label: hasLabel("marketCap") !== false ? hasLabel("marketCap") : "Market Cap",
                            className: "marketCap",
                        },
                        price: {
                            label: hasLabel("price") !== false ? hasLabel("price") : "Preço",
                            className: "price",
                        },
                        dtMin52: {
                            label: hasLabel("dtMin52") !== false ? hasLabel("dtMin52") : "Data MIN52",
                            className: "dtMin52",
                        },
                        dtMax52: {
                            label: hasLabel("dtMax52") !== false ? hasLabel("dtMax52") : "Data MAX52",
                            className: "dtMax52",
                        },
                        time: {
                            label: hasLabel("time") !== false ? hasLabel("time") : "Hora",
                            className: "time",
                        },
                        max52: {
                            label: hasLabel("max52") !== false ? hasLabel("max52") : "Max52",
                            className: "max52",
                        },
                        min52: {
                            label: hasLabel("min52") !== false ? hasLabel("min52") : "Min52",
                            className: "min52",
                        },
                    };

                    Object.keys(liveObj).forEach(function (item) {
                        templatePT[item] = liveObj[item];
                    });
                }

                return headerTemplate(templatePT, params);
            },
            "pt-br": function () {
                var templatePTBR = {
                    date: {
                        label: hasLabel("date") !== false ? hasLabel("date") : "Data",
                        className: "date",
                    },
                    var: {
                        label: hasLabel("var") !== false ? hasLabel("var") : "Variação (%)",
                        className: "var variation",
                    },
                    high: {
                        label: hasLabel("high") !== false ? hasLabel("high") : "Máxima",
                        className: "max high",
                    },
                    low: {
                        label: hasLabel("low") !== false ? hasLabel("low") : "Mínima",
                        className: "min low",
                    },
                    open: {
                        label: hasLabel("open") !== false ? hasLabel("open") : "Aberto",
                        className: "open",
                    },
                    closed: {
                        label: hasLabel("closed") !== false ? hasLabel("closed") : "Fechado",
                        className: "closed",
                    },
                    middle: {
                        label: hasLabel("middle") !== false ? hasLabel("middle") : "Média",
                        className: "middle",
                    },
                    vol: {
                        label: hasLabel("vol") !== false ? hasLabel("vol") : "Volume",
                        className: "vol",
                    },
                    share: {
                        label: hasLabel("share") !== false ? hasLabel("share") : "Quantidade",
                        className: "share",
                    },
                    trade: {
                        label: hasLabel("trade") !== false ? hasLabel("trade") : "Negócios",
                        className: "trade",
                    },
                };

                if (params.template.type === "live") {
                    var liveObj = {
                        marketCap: {
                            label: hasLabel("marketCap") !== false ? hasLabel("marketCap") : "Market Cap",
                            className: "marketCap",
                        },
                        price: {
                            label: hasLabel("price") !== false ? hasLabel("price") : "Preço",
                            className: "price",
                        },
                        dtMin52: {
                            label: hasLabel("dtMin52") !== false ? hasLabel("dtMin52") : "Data MIN52",
                            className: "dtMin52",
                        },
                        dtMax52: {
                            label: hasLabel("dtMax52") !== false ? hasLabel("dtMax52") : "Data MAX52",
                            className: "dtMax52",
                        },
                        time: {
                            label: hasLabel("time") !== false ? hasLabel("time") : "Hora",
                            className: "time",
                        },
                        max52: {
                            label: hasLabel("max52") !== false ? hasLabel("max52") : "Max52",
                            className: "max52",
                        },
                        min52: {
                            label: hasLabel("min52") !== false ? hasLabel("min52") : "Min52",
                            className: "min52",
                        },
                    };

                    Object.keys(liveObj).forEach(function (item) {
                        templatePTBR[item] = liveObj[item];
                    });
                }

                return headerTemplate(templatePTBR, params);
            },
            es: function () {
                var templateES = {
                    date: {
                        label: hasLabel("date") !== false ? hasLabel("date") : "Fecha",
                        className: "date",
                    },
                    var: {
                        label: hasLabel("var") !== false ? hasLabel("var") : "Variación (%)",
                        className: "var variation",
                    },
                    high: {
                        label: hasLabel("high") !== false ? hasLabel("high") : "Máxima",
                        className: "max high",
                    },
                    low: {
                        label: hasLabel("low") !== false ? hasLabel("low") : "Minimo",
                        className: "min low",
                    },
                    open: {
                        label: hasLabel("open") !== false ? hasLabel("open") : "Abierto",
                        className: "open",
                    },
                    closed: {
                        label: hasLabel("closed") !== false ? hasLabel("closed") : "Cerrado",
                        className: "closed",
                    },
                    middle: {
                        label: hasLabel("middle") !== false ? hasLabel("middle") : "Promedio",
                        className: "middle",
                    },
                    vol: {
                        label: hasLabel("vol") !== false ? hasLabel("vol") : "Volumen",
                        className: "vol",
                    },
                    share: {
                        label: hasLabel("share") !== false ? hasLabel("share") : "Cantidad",
                        className: "share",
                    },
                    trade: {
                        label: hasLabel("trade") !== false ? hasLabel("trade") : "Negocios",
                        className: "trade",
                    },
                };

                if (params.template.type === "live") {
                    var liveObj = {
                        marketCap: {
                            label: hasLabel("marketCap") !== false ? hasLabel("marketCap") : "Market Cap",
                            className: "marketCap",
                        },
                        price: {
                            label: hasLabel("price") !== false ? hasLabel("price") : "Precio",
                            className: "price",
                        },
                        dtMin52: {
                            label: hasLabel("dtMin52") !== false ? hasLabel("dtMin52") : "Fecha MIN52",
                            className: "dtMin52",
                        },
                        dtMax52: {
                            label: hasLabel("dtMax52") !== false ? hasLabel("dtMax52") : "Fecha MAX52",
                            className: "dtMax52",
                        },
                        time: {
                            label: hasLabel("time") !== false ? hasLabel("time") : "Tiempo",
                            className: "time",
                        },
                        max52: {
                            label: hasLabel("max52") !== false ? hasLabel("max52") : "Max52",
                            className: "max52",
                        },
                        min52: {
                            label: hasLabel("min52") !== false ? hasLabel("min52") : "Min52",
                            className: "min52",
                        },
                    };
                    Object.keys(liveObj).forEach(function (item) {
                        templateES[item] = liveObj[item];
                    });
                }

                return headerTemplate(templateES, params);
            },
            "es-es": function () {
                var templateESES = {
                    date: {
                        label: hasLabel("date") !== false ? hasLabel("date") : "Fecha",
                        className: "date",
                    },
                    var: {
                        label: hasLabel("var") !== false ? hasLabel("var") : "Variación (%)",
                        className: "var variation",
                    },
                    high: {
                        label: hasLabel("high") !== false ? hasLabel("high") : "Máxima",
                        className: "max high",
                    },
                    low: {
                        label: hasLabel("low") !== false ? hasLabel("low") : "Minimo",
                        className: "min low",
                    },
                    open: {
                        label: hasLabel("open") !== false ? hasLabel("open") : "Abierto",
                        className: "open",
                    },
                    closed: {
                        label: hasLabel("closed") !== false ? hasLabel("closed") : "Cerrado",
                        className: "closed",
                    },
                    middle: {
                        label: hasLabel("middle") !== false ? hasLabel("middle") : "Promedio",
                        className: "middle",
                    },
                    vol: {
                        label: hasLabel("vol") !== false ? hasLabel("vol") : "Volumen",
                        className: "vol",
                    },
                    share: {
                        label: hasLabel("share") !== false ? hasLabel("share") : "Cantidad",
                        className: "share",
                    },
                    trade: {
                        label: hasLabel("trade") !== false ? hasLabel("trade") : "Negocios",
                        className: "trade",
                    },
                };

                if (params.template.type === "live") {
                    var liveObj = {
                        marketCap: {
                            label: hasLabel("marketCap") !== false ? hasLabel("marketCap") : "Market Cap",
                            className: "marketCap",
                        },
                        price: {
                            label: hasLabel("price") !== false ? hasLabel("price") : "Precio",
                            className: "price",
                        },
                        dtMin52: {
                            label: hasLabel("dtMin52") !== false ? hasLabel("dtMin52") : "Fecha MIN52",
                            className: "dtMin52",
                        },
                        dtMax52: {
                            label: hasLabel("dtMax52") !== false ? hasLabel("dtMax52") : "Fecha MAX52",
                            className: "dtMax52",
                        },
                        time: {
                            label: hasLabel("time") !== false ? hasLabel("time") : "Tiempo",
                            className: "time",
                        },
                        max52: {
                            label: hasLabel("max52") !== false ? hasLabel("max52") : "Max52",
                            className: "max52",
                        },
                        min52: {
                            label: hasLabel("min52") !== false ? hasLabel("min52") : "Min52",
                            className: "min52",
                        },
                    };
                    Object.keys(liveObj).forEach(function (item) {
                        templateESES[item] = liveObj[item];
                    });
                }

                return headerTemplate(templateESES, params);
            },
            en: function () {
                var templateEN = {
                    date: {
                        label: hasLabel("date") !== false ? hasLabel("date") : "Date",
                        className: "date",
                    },
                    var: {
                        label: hasLabel("var") !== false ? hasLabel("var") : "Variation (%)",
                        className: "var variation",
                    },
                    high: {
                        label: hasLabel("high") !== false ? hasLabel("high") : "High",
                        className: "max high",
                    },
                    low: {
                        label: hasLabel("low") !== false ? hasLabel("low") : "Low",
                        className: "min low",
                    },
                    open: {
                        label: hasLabel("open") !== false ? hasLabel("open") : "Open",
                        className: "open",
                    },
                    closed: {
                        label: hasLabel("closed") !== false ? hasLabel("closed") : "Closed",
                        className: "closed",
                    },
                    middle: {
                        label: hasLabel("middle") !== false ? hasLabel("middle") : "Middle",
                        className: "middle",
                    },
                    vol: {
                        label: hasLabel("vol") !== false ? hasLabel("vol") : "Volume",
                        className: "vol",
                    },
                    share: {
                        label: hasLabel("share") !== false ? hasLabel("share") : "Shares",
                        className: "share",
                    },
                    trade: {
                        label: hasLabel("trade") !== false ? hasLabel("trade") : "Trades",
                        className: "trade",
                    },
                };

                if (params.template.type === "live") {
                    var liveObj = {
                        marketCap: {
                            label: hasLabel("marketCap") !== false ? hasLabel("marketCap") : "Market Cap",
                            className: "marketCap",
                        },
                        price: {
                            label: hasLabel("price") !== false ? hasLabel("price") : "Price",
                            className: "price",
                        },
                        dtMin52: {
                            label: hasLabel("dtMin52") !== false ? hasLabel("dtMin52") : "Date MIN52",
                            className: "dtMin52",
                        },
                        dtMax52: {
                            label: hasLabel("dtMax52") !== false ? hasLabel("dtMax52") : "Date MAX52",
                            className: "dtMax52",
                        },
                        time: {
                            label: hasLabel("time") !== false ? hasLabel("time") : "Time",
                            className: "time",
                        },
                        max52: {
                            label: hasLabel("max52") !== false ? hasLabel("max52") : "Max52",
                            className: "max52",
                        },
                        min52: {
                            label: hasLabel("min52") !== false ? hasLabel("min52") : "Min52",
                            className: "min52",
                        },
                    };
                    Object.keys(liveObj).forEach(function (item) {
                        templateEN[item] = liveObj[item];
                    });
                }

                return headerTemplate(templateEN, params);
            },
            "zh-hant": function () {
                var templateZHTW = {
                    date: {
                        label: hasLabel("date") !== false ? hasLabel("date") : "日期",
                        className: "date",
                    },
                    var: {
                        label: hasLabel("var") !== false ? hasLabel("var") : "變化（％）",
                        className: "var variation",
                    },
                    high: {
                        label: hasLabel("high") !== false ? hasLabel("high") : "最大限度",
                        className: "max high",
                    },
                    low: {
                        label: hasLabel("low") !== false ? hasLabel("low") : "最低限度",
                        className: "min low",
                    },
                    open: {
                        label: hasLabel("open") !== false ? hasLabel("open") : "打開",
                        className: "open",
                    },
                    closed: {
                        label: hasLabel("closed") !== false ? hasLabel("closed") : "關閉",
                        className: "closed",
                    },
                    middle: {
                        label: hasLabel("middle") !== false ? hasLabel("middle") : "平均",
                        className: "middle",
                    },
                    vol: {
                        label: hasLabel("vol") !== false ? hasLabel("vol") : "體積",
                        className: "vol",
                    },
                    share: {
                        label: hasLabel("share") !== false ? hasLabel("share") : "數量",
                        className: "share",
                    },
                    trade: {
                        label: hasLabel("trade") !== false ? hasLabel("trade") : "商業",
                        className: "trade",
                    },
                };

                if (params.template.type === "live") {
                    var liveObj = {
                        marketCap: {
                            label: hasLabel("marketCap") !== false ? hasLabel("marketCap") : "市值",
                            className: "marketCap",
                        },
                        price: {
                            label: hasLabel("price") !== false ? hasLabel("price") : "價格",
                            className: "price",
                        },
                        dtMin52: {
                            label: hasLabel("dtMin52") !== false ? hasLabel("dtMin52") : "最少約會52",
                            className: "dtMin52",
                        },
                        dtMax52: {
                            label: hasLabel("dtMax52") !== false ? hasLabel("dtMax52") : "最長日期52",
                            className: "dtMax52",
                        },
                        time: {
                            label: hasLabel("time") !== false ? hasLabel("time") : "小時",
                            className: "time",
                        },
                        max52: {
                            label: hasLabel("max52") !== false ? hasLabel("max52") : "最多52",
                            className: "max52",
                        },
                        min52: {
                            label: hasLabel("min52") !== false ? hasLabel("min52") : "最低52",
                            className: "min52",
                        },
                    };

                    Object.keys(liveObj).forEach(function (item) {
                        templateZHTW[item] = liveObj[item];
                    });
                }

                return headerTemplate(templateZHTW, params);
            },
            "zh-hans": function () {
                var templateZHCN = {
                    date: {
                        label: hasLabel("date") !== false ? hasLabel("date") : "日期",
                        className: "date",
                    },
                    var: {
                        label: hasLabel("var") !== false ? hasLabel("var") : "变化（％）",
                        className: "var variation",
                    },
                    high: {
                        label: hasLabel("high") !== false ? hasLabel("high") : "最大限度",
                        className: "max high",
                    },
                    low: {
                        label: hasLabel("low") !== false ? hasLabel("low") : "最低限度",
                        className: "min low",
                    },
                    open: {
                        label: hasLabel("open") !== false ? hasLabel("open") : "打开",
                        className: "open",
                    },
                    closed: {
                        label: hasLabel("closed") !== false ? hasLabel("closed") : "关闭",
                        className: "closed",
                    },
                    middle: {
                        label: hasLabel("middle") !== false ? hasLabel("middle") : "平均",
                        className: "middle",
                    },
                    vol: {
                        label: hasLabel("vol") !== false ? hasLabel("vol") : "体积",
                        className: "vol",
                    },
                    share: {
                        label: hasLabel("share") !== false ? hasLabel("share") : "数量",
                        className: "share",
                    },
                    trade: {
                        label: hasLabel("trade") !== false ? hasLabel("trade") : "商业",
                        className: "trade",
                    },
                };

                if (params.template.type === "live") {
                    var liveObj = {
                        marketCap: {
                            label: hasLabel("marketCap") !== false ? hasLabel("marketCap") : "市值",
                            className: "marketCap",
                        },
                        price: {
                            label: hasLabel("price") !== false ? hasLabel("price") : "价格",
                            className: "price",
                        },
                        dtMin52: {
                            label: hasLabel("dtMin52") !== false ? hasLabel("dtMin52") : "最少约会52",
                            className: "dtMin52",
                        },
                        dtMax52: {
                            label: hasLabel("dtMax52") !== false ? hasLabel("dtMax52") : "最长日期52",
                            className: "dtMax52",
                        },
                        time: {
                            label: hasLabel("time") !== false ? hasLabel("time") : "小时",
                            className: "time",
                        },
                        max52: {
                            label: hasLabel("max52") !== false ? hasLabel("max52") : "最多52",
                            className: "max52",
                        },
                        min52: {
                            label: hasLabel("min52") !== false ? hasLabel("min52") : "最低52",
                            className: "min52",
                        },
                    };

                    Object.keys(liveObj).forEach(function (item) {
                        templateZHCN[item] = liveObj[item];
                    });
                }

                return headerTemplate(templateZHCN, params);
            },
            fr: function () {
                var templateEN = {
                    date: {
                        label: hasLabel("date") !== false ? hasLabel("date") : "Date",
                        className: "date",
                    },
                    var: {
                        label: hasLabel("var") !== false ? hasLabel("var") : "Variation (%)",
                        className: "var variation",
                    },
                    high: {
                        label: hasLabel("high") !== false ? hasLabel("high") : "Haut",
                        className: "max high",
                    },
                    low: {
                        label: hasLabel("low") !== false ? hasLabel("low") : "Faible",
                        className: "min low",
                    },
                    open: {
                        label: hasLabel("open") !== false ? hasLabel("open") : "Ouvrir",
                        className: "open",
                    },
                    closed: {
                        label: hasLabel("closed") !== false ? hasLabel("closed") : "Fermé",
                        className: "closed",
                    },
                    middle: {
                        label: hasLabel("middle") !== false ? hasLabel("middle") : "Milieu",
                        className: "middle",
                    },
                    vol: {
                        label: hasLabel("vol") !== false ? hasLabel("vol") : "Le volume",
                        className: "vol",
                    },
                    share: {
                        label: hasLabel("share") !== false ? hasLabel("share") : "Actions",
                        className: "share",
                    },
                    trade: {
                        label: hasLabel("trade") !== false ? hasLabel("trade") : "Métiers",
                        className: "trade",
                    },
                };

                if (params.template.type === "live") {
                    var liveObj = {
                        marketCap: {
                            label: hasLabel("marketCap") !== false ? hasLabel("marketCap") : "Capitalisation Boursière",
                            className: "marketCap",
                        },
                        price: {
                            label: hasLabel("price") !== false ? hasLabel("price") : "Prix",
                            className: "price",
                        },
                        dtMin52: {
                            label: hasLabel("dtMin52") !== false ? hasLabel("dtMin52") : "Date MIN52",
                            className: "dtMin52",
                        },
                        dtMax52: {
                            label: hasLabel("dtMax52") !== false ? hasLabel("dtMax52") : "Date MAX52",
                            className: "dtMax52",
                        },
                        time: {
                            label: hasLabel("time") !== false ? hasLabel("time") : "Temps",
                            className: "time",
                        },
                        max52: {
                            label: hasLabel("max52") !== false ? hasLabel("max52") : "Max52",
                            className: "max52",
                        },
                        min52: {
                            label: hasLabel("min52") !== false ? hasLabel("min52") : "Min52",
                            className: "min52",
                        },
                    };
                    Object.keys(liveObj).forEach(function (item) {
                        templateEN[item] = liveObj[item];
                    });
                }

                return headerTemplate(templateEN, params);
            },
            de: function () {
                var templateEN = {
                    date: {
                        label: hasLabel("date") !== false ? hasLabel("date") : "Datum",
                        className: "date",
                    },
                    var: {
                        label: hasLabel("var") !== false ? hasLabel("var") : "Variation (%)",
                        className: "var variation",
                    },
                    high: {
                        label: hasLabel("high") !== false ? hasLabel("high") : "Hoch",
                        className: "max high",
                    },
                    low: {
                        label: hasLabel("low") !== false ? hasLabel("low") : "Niedrig",
                        className: "min low",
                    },
                    open: {
                        label: hasLabel("open") !== false ? hasLabel("open") : "Öffnen",
                        className: "open",
                    },
                    closed: {
                        label: hasLabel("closed") !== false ? hasLabel("closed") : "Geschlossen",
                        className: "closed",
                    },
                    middle: {
                        label: hasLabel("middle") !== false ? hasLabel("middle") : "Mitte",
                        className: "middle",
                    },
                    vol: {
                        label: hasLabel("vol") !== false ? hasLabel("vol") : "Volumen",
                        className: "vol",
                    },
                    share: {
                        label: hasLabel("share") !== false ? hasLabel("share") : "Anteile",
                        className: "share",
                    },
                    trade: {
                        label: hasLabel("trade") !== false ? hasLabel("trade") : "Trades",
                        className: "trade",
                    },
                };

                if (params.template.type === "live") {
                    var liveObj = {
                        marketCap: {
                            label: hasLabel("marketCap") !== false ? hasLabel("marketCap") : "Marktkapitalisierung",
                            className: "marketCap",
                        },
                        price: {
                            label: hasLabel("price") !== false ? hasLabel("price") : "Preis",
                            className: "price",
                        },
                        dtMin52: {
                            label: hasLabel("dtMin52") !== false ? hasLabel("dtMin52") : "Datum MIN52",
                            className: "dtMin52",
                        },
                        dtMax52: {
                            label: hasLabel("dtMax52") !== false ? hasLabel("dtMax52") : "Datum MAX52",
                            className: "dtMax52",
                        },
                        time: {
                            label: hasLabel("time") !== false ? hasLabel("time") : "Zeit",
                            className: "time",
                        },
                        max52: {
                            label: hasLabel("max52") !== false ? hasLabel("max52") : "Max52",
                            className: "max52",
                        },
                        min52: {
                            label: hasLabel("min52") !== false ? hasLabel("min52") : "Min52",
                            className: "min52",
                        },
                    };
                    Object.keys(liveObj).forEach(function (item) {
                        templateEN[item] = liveObj[item];
                    });
                }

                return headerTemplate(templateEN, params);
            },
        };

        return header[self.LANGUAGE]();
    }

    function loadHistoryParams(params) {
        self.STOCK_ID = params.stockinfoId;
        self.TICKER = params.tickers;
        self.IS_INDEX = params.isIndex;
        self.LANGUAGE = params.language ? params.language : "pt";
        self.ADJUSTED = params.adjusted ? params.adjusted : self.ADJUSTED;

        if (params.startDate) self.START_DATE = moment(params.startDate, "YYYY-MM-DD");
        if (params.endDate) self.END_DATE = moment(params.endDate, "YYYY-MM-DD");

        switchTickerIndex = self.IS_INDEX ? "&indexes=" + self.TICKER : "&tickers=" + self.TICKER;

        self.MOMENT_DATE_FORMAT = params.language === "pt" || params.language === "es" ? "DD/MM/YYYY" : "MM/DD/YYYY";
        self.DATEPICKER_DATE_FORMAT = params.language === "pt" || params.language === "es" ? "dd/mm/yy" : "mm/dd/yy";

        self.CURRENCY_SYMBOL = params.currencySymbol ? params.currencySymbol : "R$";
        self.DECIMAL_PLACES = params.decimalPlaces ? params.decimalPlaces : 2;

        var labels = {
            pt: {
                startDate: "Data inicial:",
                endDate: "Data final:",
                interval: "Intervalo máximo: 20 anos",
                search: "Pesquisar",
                excel: "Exportar",
                source: "Fonte",
            },
            "pt-br": {
                startDate: "Data inicial:",
                endDate: "Data final:",
                interval: "Intervalo máximo: 20 anos",
                search: "Pesquisar",
                excel: "Exportar",
                source: "Fonte",
            },
            es: {
                startDate: "Fecha de inicio:",
                endDate: "Fecha final:",
                interval: "Intervalo máximo: 20 años",
                excel: "Exportación",
                search: "Buscar",
                source: "Fuente",
            },
            "es-es": {
                startDate: "Fecha de inicio:",
                endDate: "Fecha final:",
                interval: "Intervalo máximo: 20 años",
                excel: "Exportación",
                search: "Buscar",
                source: "Fuente",
            },
            en: {
                startDate: "Initial date:",
                endDate: "Final date:",
                interval: "Maximal delay: 20 years",
                search: "Search",
                excel: "Export",
                source: "Source",
            },
            "zh-hant": {
                startDate: "初始日期：",
                endDate: "截止日期：",
                interval: "最長間隔：20年",
                search: "搜索",
                excel: "出口",
                source: "來源",
            },
            "zh-hans": {
                startDate: "初始日期：",
                endDate: "截止日期：",
                interval: "最长间隔：20年",
                search: "搜索",
                excel: "出口",
                source: "来源",
            },
            fr: {
                startDate: "La date initiale:",
                endDate: "Date finale:",
                interval: "Délai maximal: 20 ans",
                search: "Chercher",
                excel: "Exportation",
                source: "La source",
            },
            de: {
                startDate: "Anfangsdatum:",
                endDate: "Endgültiges Datum:",
                interval: "Maximale Verzögerung: 20 Jahre",
                search: "Suche",
                excel: "Export",
                source: "Quelle",
            },
        };

        var initialTemplate =
            '<div class="mziq-quotations">' +
            '<div class="scroll">' +
            '<div class="ticker-infos historyTabularPrices">' +
            '<div class="historyTickerIdentification">' +
            "</div>" +
            '<form  id="historyForm">' +
            '<div class="form-inline">' +
            '<div class="first">' +
            '<label for="txtStartDate">' +
            labels[self.LANGUAGE].startDate +
            "</label>" +
            '<input type="text" id="txtStartDate" name="txtStartDate" class="form-control mr20">' +
            "</div>" +
            "<div>" +
            '<label for="txtEndDate">' +
            labels[self.LANGUAGE].endDate +
            "</label>" +
            '<input type="text" id="txtEndDate" name="txtEndDate" class="form-control">' +
            "</div>" +
            '<div class="last">' +
            '<button id="btnSearchHistory" class="btn btn-default">' +
            labels[self.LANGUAGE].search +
            "</button>" +
            '<a class="btn btn-close" href=""><i class="fa fa-close"></i></a>' +
            '<label class="info">* ' +
            labels[self.LANGUAGE].interval +
            "</label>" +
            "</div>" +
            '<a href="#" id="btnExportToExcel" class="btn btn-export">' +
            labels[self.LANGUAGE].excel +
            "</a>" +
            "</div>" +
            "</form>" +
            '<table class="table__history" cellspacing="0" cellpadding="0">' +
            showTableHeader(params) +
            "<tbody>" +
            '<tr class="loading">' +
            '<td colspan="10">' +
            "</td>" +
            "</tr>" +
            "</tbody>" +
            "<tfoot>" +
            "<tr>" +
            '<td colspan="10" class="fonte" id="source">' +
            labels[self.LANGUAGE].source +
            ': <a href="http://www.enfoque.com.br/" target="_blank">Enfoque</a></td>' +
            "</tr>" +
            "</tfoot>" +
            "</table>" +
            "</div>" +
            "</div>" +
            "</div>";

        $(self.rootElement).append(initialTemplate);
        $(".historyTickerIdentification").html(self.TICKER);
    }

    function initDatePicker() {
        var startDateInput = $("#txtStartDate");

        startDateInput.val(self.START_DATE.format(self.MOMENT_DATE_FORMAT));
        startDateInput.datepicker({
            changeMonth: true,
            changeYear: true,
            numberOfMonths: 1,
            dateFormat: self.DATEPICKER_DATE_FORMAT,
            maxDate: 0,
            minDate: "-20Y",
            yearRange: "c-20:c+0",
            onSelect: function (dateText, inst) {
                self.START_DATE = moment(dateText, self.MOMENT_DATE_FORMAT);
            },
        });

        var endDateInput = $("#txtEndDate");

        endDateInput.val(self.END_DATE.format(self.MOMENT_DATE_FORMAT));
        endDateInput.datepicker({
            changeMonth: true,
            changeYear: true,
            numberOfMonths: 1,
            dateFormat: self.DATEPICKER_DATE_FORMAT,
            maxDate: 0,
            minDate: "-20Y",
            yearRange: "c-20:c+0",
            onSelect: function (dateText, inst) {
                self.END_DATE = moment(dateText, self.MOMENT_DATE_FORMAT);
            },
        });
    }

    function moveColumn(params, customOrder) {
        var columns = params.template.columns;

        if (!!customOrder && !params.template.columns) {
            var custom = [];

            custom.push("ticker");

            Object.keys(customOrder).forEach(function (item) {
                custom.push(item);
            });

            columns = custom;
        }

        if (!columns || columns === undefined) {
            return false;
        }

        columns.forEach(function (item, index) {
            var $elementsHeader = $("thead tr th." + item);
            var $items = $("tbody tr");

            $elementsHeader.parent().append($elementsHeader);

            $items.each(function () {
                var $elementsItem = $(this).find("." + item);
                $elementsItem.parent().append($elementsItem);
            });
        });
    }

    function initSearchButton(params) {
        var btnSearchHistory = $("#btnSearchHistory");

        var errorText = {
            wrong_date: {
                pt: "Data inicial deve ser menor ou igual a data final!",
                "pt-br": "Data inicial deve ser menor ou igual a data final!",
                es: "¡La fecha inicial debe ser menor o igual a la fecha final!",
                "es-es": "¡La fecha inicial debe ser menor o igual a la fecha final!",
                en: "Initial date must be minor or equal than the final date!",
                "zh-hant": "開始日期必須小於或等於結束日期！",
                "zh-hans": "开始日期必须小于或等于结束日期！",
                fr: "La date initiale doit être mineure ou égale à la date finale!",
                de: "Das Anfangsdatum muss geringfügig oder gleich dem Enddatum sein!",
            },
            all_fields: {
                pt: "Preencha todos os campos de data!",
                "pt-br": "Preencha todos os campos de data!",
                es: "Por favor, rellene todos los campos de fecha!",
                "es-es": "Por favor, rellene todos los campos de fecha!",
                en: "Please, fill all date fields!",
                "zh-hant": "填寫所有日期字段！",
                "zh-hans": "填写所有日期字段！",
                fr: "Veuillez remplir tous les champs de date!",
                de: "Bitte füllen Sie alle Datumsfelder aus!",
            },
        };

        btnSearchHistory.on("click", function (e) {
            e && e.preventDefault();

            if (self.START_DATE > self.END_DATE) {
                alert(errorText.wrong_date[params.language]);
                console.error(errorText.wrong_date[params.language]);
                return;
            }

            if ($("#txtStartDate").val() === "" || $("#txtEndDate").val() === "") {
                alert(errorText.all_fields[params.language]);
                console.error(errorText.all_fields[params.language]);
                return;
            }

            resetHistoryTableData(true);
            loadHistoryData(params);
        });
    }

    function initExportExcelButton() {
        var btnExport = $("#btnExportToExcel");

        btnExport.on("click", function (e) {
            e && e.preventDefault();
            if (self.LANGUAGE === "pt-br" || self.LANGUAGE === "pt") {
                langIdiom = "1";
            } else if (self.LANGUAGE === "es") {
                langIdiom = "1";
            } else if (self.LANGUAGE === "zh-hans") {
                langIdiom = "2";
            } else if (self.LANGUAGE === "zh-hant") {
                langIdiom = "3";
            } else if (self.LANGUAGE === "fr-fr" || self.LANGUAGE === "fr") {
                langIdiom = "4";
            } else if (self.LANGUAGE === "de-de" || self.LANGUAGE === "de") {
                langIdiom = "5";
            } else {
                langIdiom = "0";
            }
            var idiom = langIdiom;
            window.open(self.API_URL + "/" + self.STOCK_ID + "/historyToExcel?from=" + self.START_DATE.format("YYYY-MM-DD") + "&to=" + self.END_DATE.format("YYYY-MM-DD") + switchTickerIndex + "&idiom=" + idiom + "&adjusted=" + self.ADJUSTED, "_blank");
        });
    }

    function loadHistoryData(params) {
        var apiUrl = self.API_URL + "/" + self.STOCK_ID + "/history?from=" + self.START_DATE.format("YYYY-MM-DD") + "&to=" + self.END_DATE.format("YYYY-MM-DD") + switchTickerIndex + "&adjusted=" + self.ADJUSTED;

        $.ajax({
            url: apiUrl,
            type: "GET",
            dataType: "json",
            success: function (result) {
                var count = self.IS_INDEX ? result.data.indexes.length : result.data.tickers.length;

                if (count === 0) {
                    console.warn("Nenhum dado encontrado!");
                    console.error("Errors", result.data.errors);
                    return;
                }

                var historyData = self.IS_INDEX ? result.data.indexes[0].history : result.data.tickers[0].history;

                resetHistoryTableData(false);
                renderHistoryHtml(historyData, result.data.source, params, result.data.link);
                logErrorsInConsole(result.data.errors);
            },
            error: function (res) {
                console.warn("Não foi possível recuperar os dados históricos. Tente novamente ou contate o suporte!");
                console.error("Erro ao recuperar dados da API: ");
                console.error(res);
            },
        });
    }

    function resetHistoryTableData(showLoading) {
        var removeTbody = [].slice.call($DOCUMENT.querySelectorAll(".table__history .item"));

        removeTbody.forEach(function (remove) {
            remove.parentNode.removeChild(remove);
        });

        if (!showLoading) {
            var removeLoading = [].slice.call($DOCUMENT.querySelectorAll(".table__history .loading"));

            removeLoading.forEach(function (remove) {
                remove.parentNode.removeChild(remove);
            });
        } else {
            $(".ticker-infos .table__history").append('<tr class="loading"><td colspan="10">Carregando...</td></tr>');
        }
    }

    function renderClassName(item, colorClass) {
        if (item === "var") {
            return "var variation " + colorClass;
        }

        return item;
    }

    function renderItemValue(item, itemValue, colorClass, isIndex) {
        if ((self.IS_INDEX === true && item === "high") || (self.IS_INDEX === true && item === "low") || (self.IS_INDEX === true && item === "middle") || (self.IS_INDEX === true && item === "open") || (self.IS_INDEX === true && item === "closed")) {
            itemValue = parseInt(itemValue.toString().replace(".", ""));
        }

        var renderValues = {
            date: function () {
                return moment(itemValue).format(self.MOMENT_DATE_FORMAT);
            },
            var: function () {
                if (itemValue === 0) {
                    return "-";
                }

                var arrowHtml = self.SHOW_VARIATION_ARROW === true ? '%  <span class="icon ' + colorClass + '"></span>' : "%";

                if (self.ARROW_IMAGES !== undefined && self.SHOW_VARIATION_ARROW === true) {
                    var imageUrl;

                    if (itemValue < 0) {
                        imageUrl = self.ARROW_IMAGES.down;
                    } else if (itemValue > 0) {
                        imageUrl = self.ARROW_IMAGES.up;
                    } else if (itemValue === 0) {
                        imageUrl = self.ARROW_IMAGES.neutral;
                    }

                    arrowHtml = '% <img class="arrow-custom-image" src="' + imageUrl + '"></img>';
                }

                return formatCurrency(itemValue, false) + arrowHtml;
            },
            high: function () {
                if (self.HAS_SHORT_MODE === true && itemValue > 1000) {
                    return isIndex === false ? self.CURRENCY_SYMBOL : "" + " " + convertToShortMode(itemValue);
                }

                return self.IS_INDEX ? formatNumber(parseInt(itemValue.toString().replace(".", "")), true, isIndex) : formatCurrency(itemValue, true, isIndex);
            },
            low: function () {
                if (self.HAS_SHORT_MODE === true && itemValue > 1000) {
                    return isIndex === false ? self.CURRENCY_SYMBOL : "" + " " + convertToShortMode(itemValue);
                }

                return self.IS_INDEX ? formatNumber(parseInt(itemValue.toString().replace(".", "")), true, isIndex) : formatCurrency(itemValue, true, isIndex);
            },
            open: function () {
                if (self.HAS_SHORT_MODE === true && itemValue > 1000) {
                    return isIndex === false ? self.CURRENCY_SYMBOL : "" + " " + convertToShortMode(itemValue);
                }

                return self.IS_INDEX ? formatNumber(parseInt(itemValue.toString().replace(".", "")), true, isIndex) : formatCurrency(itemValue, true, isIndex);
            },
            closed: function () {
                if (self.HAS_SHORT_MODE === true && itemValue > 1000) {
                    return isIndex === false ? self.CURRENCY_SYMBOL : "" + " " + convertToShortMode(itemValue);
                }
                return self.IS_INDEX ? formatNumber(parseInt(itemValue.toString().replace(".", "")), true, isIndex) : formatCurrency(itemValue, true, isIndex);
            },
            middle: function () {
                if (self.HAS_SHORT_MODE === true && itemValue > 1000) {
                    return isIndex === false ? self.CURRENCY_SYMBOL : "" + " " + convertToShortMode(itemValue);
                }
                return self.IS_INDEX ? formatNumber(parseInt(itemValue.toString().replace(".", "")), true, isIndex) : formatCurrency(itemValue, true, isIndex);
            },
            vol: function () {
                if (self.HAS_SHORT_MODE === true && itemValue > 1000) {
                    return convertToShortMode(itemValue);
                }
                return formatNumber(itemValue, false, isIndex);
            },
            share: function () {
                if (self.HAS_SHORT_MODE === true && itemValue > 1000) {
                    return convertToShortMode(itemValue);
                }
                return formatNumber(itemValue, false, isIndex);
            },
            trade: function () {
                if (self.HAS_SHORT_MODE === true && itemValue > 1000) {
                    return convertToShortMode(itemValue);
                }
                return formatNumber(itemValue, false, isIndex);
            },
            marketCap: function () {
                if (self.HAS_SHORT_MODE === true && itemValue > 1000) {
                    return convertToShortMode(itemValue);
                }
                return formatNumber(itemValue, false, isIndex);
            },
            price: function () {
                if (self.HAS_SHORT_MODE === true && itemValue > 1000) {
                    return isIndex === false ? self.CURRENCY_SYMBOL : "" + " " + convertToShortMode(itemValue);
                }
                return formatCurrency(itemValue, true, isIndex);
            },
            dtMin52: function () {
                return moment(itemValue).format(self.MOMENT_DATE_FORMAT);
            },
            dtMax52: function () {
                return moment(itemValue).format(self.MOMENT_DATE_FORMAT);
            },
            time: function () {
                return itemValue;
            },
            max52: function () {
                if (self.HAS_SHORT_MODE === true && itemValue > 1000) {
                    return isIndex === false ? self.CURRENCY_SYMBOL : "" + " " + convertToShortMode(itemValue);
                }

                return self.IS_INDEX ? formatNumber(parseInt(itemValue.toString().replace(".", "")), true, isIndex) : formatCurrency(itemValue, true, isIndex);
            },
            min52: function () {
                if (self.HAS_SHORT_MODE === true && itemValue > 1000) {
                    return isIndex === false ? self.CURRENCY_SYMBOL : "" + " " + convertToShortMode(itemValue);
                }

                return self.IS_INDEX ? formatNumber(parseInt(itemValue.toString().replace(".", "")), true, isIndex) : formatCurrency(itemValue, true, isIndex);
            },
        };

        return renderValues[item]();
    }

    function renderLegends(params) {
        if (!params.template.suffix) {
            return "";
        }

        $(self.rootElement).find(".custom-item.legend").remove();

        params.template.suffix.map(function (item) {
            if (item.isLegend === true) {
                $(self.rootElement).append('<p class="custom-item legend">' + item.symbol + " - " + item.legend + "</p>");
            }
        });
    }

    function renderPreffix(params, field) {
        if (!params.template.preffix) {
            return "";
        }

        var item = params.template.preffix
            .filter(function (item) {
                return item.field === field;
            })
            .pop();

        if (item !== undefined) {
            return '<span class="symbol preffix">' + item.symbol + "</span>";
        }

        return "";
    }

    function renderSuffix(params, field) {
        if (!params.template.suffix) {
            return "";
        }
        var item = params.template.suffix
            .filter(function (item) {
                return item.field === field;
            })
            .pop();

        if (item !== undefined) {
            return '<span class="symbol suffix">' + item.symbol + "</span>";
        }

        return "";
    }

    function renderHistoryHtml(historyData, source, params, link) {
        $(".custom-arrow-td").remove();

        $.each(historyData, function (historyItem) {
            var itemsToRender = historyData[historyItem];
            var colorClass = "up";
            var itemTr = document.createElement("tr");

            if (this.var < 0) {
                colorClass = "down";
            }

            colorClass = this.var === 0 ? "neutral" : colorClass;

            itemTr.className = "item";

            $(".ticker-infos .table__history").append(itemTr);

            Object.keys(itemsToRender).forEach(function (item) {
                if (!!params.template.columns && !params.template.columns.includes(item)) {
                    return false;
                }

                var itemValue = historyData[historyItem][item];

                $(itemTr).append('<td class="' + renderClassName(item, colorClass) + '">' + renderPreffix(params, item) + renderItemValue(item, itemValue, colorClass) + renderSuffix(params, item) + "</td>");
            });
            if (!!params.template.customArrow) {
                if (self.ARROW_IMAGES !== undefined) {
                    var imageUrl;

                    if (historyData[historyItem].var < 0) {
                        imageUrl = self.ARROW_IMAGES.down;
                    } else if (historyData[historyItem].var > 0) {
                        imageUrl = self.ARROW_IMAGES.up;
                    } else if (historyData[historyItem].var === 0) {
                        imageUrl = self.ARROW_IMAGES.neutral;
                    }

                    $(itemTr).append('<td class="arrow custom-arrow-td"><img class="custom-arrow-image" src="' + imageUrl + '"></img></td>');
                } else {
                    var customClass = historyData[historyItem].var < 0 ? "down" : "up";
                    $(itemTr).append('<td class="arrow custom-arrow-td"><span class="custom-arrow-default ' + customClass + '"></span></td>');
                }
            }
        });

        var hasLabelRender = function (parameter) {
            if (!!params.customLabels && !!params.customLabels[parameter]) {
                return params.customLabels[parameter];
            }
            return false;
        };

        var arrowLabel = hasLabelRender("arrow") !== false ? hasLabelRender("arrow") : "Arrow";

        if (!!params.template.customArrow) {
            $("th.arrow.custom-arrow").remove();
            $(".ticker-infos .table__history thead tr").append('<th class="arrow custom-arrow">' + arrowLabel + "</th>");
        }

        moveColumn(params);

        var sourceText = {
            pt: "Fonte: ",
            "pt-br": "Fonte: ",
            es: "Fuente: ",
            "es-es": "Fuente: ",
            en: "Source: ",
            "zh-hant": "來源: ",
            "zh-hans": "来源: ",
            fr: "La source: ",
            de: "Quelle: ",
        };

        $("#source").html("<a href=" + link + ' target="_blank">' + sourceText[params.language] + source + "</a>");

        renderLegends(params);
    }

    function stockinfoChart(params) {
        loadChartParams(params);
        loadHighstockParams(params);
        loadChartData(params);
    }

    function loadChartParams(params) {
        self.STOCK_ID = params.stockinfoId;
        self.LANGUAGE = params.language ? params.language : "pt";
        chartType = params.chartType ? params.chartType : "line";
        chartColors = params.chartColors ? params.chartColors : ["#42677c", "#B22222", "#008000", "#FF8C00", "#FF00FF", "#00BFFF"];
        self.MOMENT_DATE_FORMAT = params.language === "pt" || params.language === "es" || params.language === "pt-br" || params.language === "es-es" ? "DD/MM/YYYY HH:mm" : "MM/DD/YYYY hh:mm A";
        chartHeight = params.height ? params.height : 400;
        self.CURRENCY_SYMBOL = params.currencySymbol ? params.currencySymbol : "R$";
        isSimpleChart = params.template.isSimpleChart ? params.template.isSimpleChart : false;
        self.TICKER = params.tickers;
        self.ADJUSTED = params.adjusted ? params.adjusted : self.ADJUSTED;
        fileManager = params.fileManager;
        eventsCalendar = params.eventsCalendar;

        if (chartType === "spline") {
            chartType = "line";
        }

        if (params.chartPeriod) {
            var chartPeriodStrategy = {
                "1m": function () {
                    self.START_DATE = moment().subtract(1, "months");
                    self.CHART_PERIOD = "1m";
                },
                "6m": function () {
                    self.START_DATE = moment().subtract(6, "months");
                    self.CHART_PERIOD = "6m";
                },
                "1y": function () {
                    self.START_DATE = moment().subtract(1, "years");
                    self.CHART_PERIOD = "1y";
                },
                "3y": function () {
                    self.START_DATE = moment().subtract(3, "years");
                    self.CHART_PERIOD = "3y";
                },
                "5y": function () {
                    self.START_DATE = moment().subtract(5, "years");
                    self.CHART_PERIOD = "5y";
                },
            };

            chartPeriodStrategy[params.chartPeriod]();
        }
    }

    function loadHighstockParams(params) {
        var highstockGlobalizedTerms = undefined;
        var rangeSelectorButtons = undefined;
        var xAxisDateFormat = undefined;

        var dateFormats = {
            pt: {
                date: "%b %e, %Y",
                edit: "%Y-%m-%d",
            },
            "pt-br": {
                date: "%b %e, %Y",
                edit: "%Y-%m-%d",
            },
            es: {
                date: "%b %e, %Y",
                edit: "%Y-%m-%d",
            },
            "es-es": {
                date: "%b %e, %Y",
                edit: "%Y-%m-%d",
            },
            en: {
                date: "%b %e, %Y",
                edit: "%Y-%m-%d",
            },
            "zh-hant": {
                date: "%b %e, %Y",
                edit: "%Y-%m-%d",
            },
            "zh-hans": {
                date: "%b %e, %Y",
                edit: "%Y-%m-%d",
            },
            fr: {
                date: "%b %e, %Y",
                edit: "%Y-%m-%d",
            },
            de: {
                date: "%b %e, %Y",
                edit: "%Y-%m-%d",
            },
        };

        // Highstock LANGUAGE
        switch (self.LANGUAGE) {
            case "pt":
                highstockGlobalizedTerms = {
                    loading: "Aguarde...",
                    months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
                    weekdays: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
                    shortMonths: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
                    rangeSelectorFrom: "De",
                    rangeSelectorTo: "Até",
                    rangeSelectorZoom: "Período",
                    decimalPoint: ",",
                    thousandsSep: ".",
                };
                rangeSelectorButtons = [
                    {
                        type: "month",
                        count: 1,
                        text: "1m",
                    },
                    {
                        type: "month",
                        count: 3,
                        text: "3m",
                    },
                    {
                        type: "month",
                        count: 6,
                        text: "6m",
                    },
                    {
                        type: "ytd",
                        text: "YTD",
                    },
                    {
                        type: "year",
                        count: 1,
                        text: "1a",
                    },
                    {
                        type: "all",
                        text: "Tudo",
                    },
                ];
                xAxisDateFormat = "{value: %d/%m}";
                break;

            case "pt-br":
                highstockGlobalizedTerms = {
                    loading: "Aguarde...",
                    months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
                    weekdays: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
                    shortMonths: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
                    rangeSelectorFrom: "De",
                    rangeSelectorTo: "Até",
                    rangeSelectorZoom: "Período",
                    decimalPoint: ",",
                    thousandsSep: ".",
                };
                rangeSelectorButtons = [
                    {
                        type: "month",
                        count: 1,
                        text: "1m",
                    },
                    {
                        type: "month",
                        count: 3,
                        text: "3m",
                    },
                    {
                        type: "month",
                        count: 6,
                        text: "6m",
                    },
                    {
                        type: "ytd",
                        text: "YTD",
                    },
                    {
                        type: "year",
                        count: 1,
                        text: "1a",
                    },
                    {
                        type: "all",
                        text: "Tudo",
                    },
                ];
                xAxisDateFormat = "{value: %d/%m}";
                break;

            case "es":
                highstockGlobalizedTerms = {
                    loading: "Por favor espere...",
                    months: ["Enero", "Febrero", "Martes", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
                    weekdays: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
                    shortMonths: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
                    rangeSelectorFrom: "De",
                    rangeSelectorTo: "Para",
                    rangeSelectorZoom: "Período",
                    decimalPoint: ",",
                    thousandsSep: ".",
                };
                rangeSelectorButtons = [
                    {
                        type: "month",
                        count: 1,
                        text: "1m",
                    },
                    {
                        type: "month",
                        count: 3,
                        text: "3m",
                    },
                    {
                        type: "month",
                        count: 6,
                        text: "6m",
                    },
                    {
                        type: "ytd",
                        text: "YTD",
                    },
                    {
                        type: "year",
                        count: 1,
                        text: "1a",
                    },
                    {
                        type: "all",
                        text: "Todos",
                    },
                ];
                xAxisDateFormat = "{value: %d/%m}";
                break;

            case "es-es":
                highstockGlobalizedTerms = {
                    loading: "Por favor espere...",
                    months: ["Enero", "Febrero", "Martes", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
                    weekdays: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
                    shortMonths: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
                    rangeSelectorFrom: "De",
                    rangeSelectorTo: "Para",
                    rangeSelectorZoom: "Período",
                    decimalPoint: ",",
                    thousandsSep: ".",
                };
                rangeSelectorButtons = [
                    {
                        type: "month",
                        count: 1,
                        text: "1m",
                    },
                    {
                        type: "month",
                        count: 3,
                        text: "3m",
                    },
                    {
                        type: "month",
                        count: 6,
                        text: "6m",
                    },
                    {
                        type: "ytd",
                        text: "YTD",
                    },
                    {
                        type: "year",
                        count: 1,
                        text: "1a",
                    },
                    {
                        type: "all",
                        text: "Todos",
                    },
                ];
                xAxisDateFormat = "{value: %d/%m}";
                break;

            case "zh-hant":
                highstockGlobalizedTerms = {
                    loading: "請稍等 ...",
                    months: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
                    weekdays: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
                    shortMonths: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
                    rangeSelectorFrom: "從",
                    rangeSelectorTo: "到",
                    rangeSelectorZoom: "時期",
                    decimalPoint: ".",
                    thousandsSep: ",",
                };
                rangeSelectorButtons = [
                    {
                        type: "month",
                        count: 1,
                        text: "1月",
                    },
                    {
                        type: "month",
                        count: 3,
                        text: "3月",
                    },
                    {
                        type: "month",
                        count: 6,
                        text: "6月",
                    },
                    {
                        type: "ytd",
                        text: "昨天",
                    },
                    {
                        type: "year",
                        count: 1,
                        text: "1年",
                    },
                    {
                        type: "all",
                        text: "全部",
                    },
                ];
                xAxisDateFormat = "{value: %m/%d}";
                break;

            case "zh-hans":
                highstockGlobalizedTerms = {
                    loading: "请稍等 ...",
                    months: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
                    weekdays: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
                    shortMonths: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
                    rangeSelectorFrom: "从",
                    rangeSelectorTo: "到",
                    rangeSelectorZoom: "时期",
                    decimalPoint: ".",
                    thousandsSep: ",",
                };
                rangeSelectorButtons = [
                    {
                        type: "month",
                        count: 1,
                        text: "1月",
                    },
                    {
                        type: "month",
                        count: 3,
                        text: "3月",
                    },
                    {
                        type: "month",
                        count: 6,
                        text: "6月",
                    },
                    {
                        type: "ytd",
                        text: "昨天",
                    },
                    {
                        type: "year",
                        count: 1,
                        text: "1年",
                    },
                    {
                        type: "all",
                        text: "全部",
                    },
                ];
                xAxisDateFormat = "{value: %m/%d}";
                break;

            case "fr":
                highstockGlobalizedTerms = {
                    loading: "S'il vous plaît, attendez...",
                    months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
                    weekdays: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
                    shortMonths: ["Jan", "Fév", "Mar", "Avr", "Peu", "Jui", "Jui", "Aoû", "Sep", "Oct", "Nov", "Déc"],
                    rangeSelectorFrom: "De",
                    rangeSelectorTo: "À",
                    rangeSelectorZoom: "Période",
                    decimalPoint: ".",
                    thousandsSep: ",",
                };
                rangeSelectorButtons = [
                    {
                        type: "month",
                        count: 1,
                        text: "1m",
                    },
                    {
                        type: "month",
                        count: 3,
                        text: "3m",
                    },
                    {
                        type: "month",
                        count: 6,
                        text: "6m",
                    },
                    {
                        type: "ytd",
                        text: "hier",
                    },
                    {
                        type: "year",
                        count: 1,
                        text: "1an",
                    },
                    {
                        type: "all",
                        text: "Tout",
                    },
                ];
                xAxisDateFormat = "{value: %m/%d}";
                break;

            case "de":
                highstockGlobalizedTerms = {
                    loading: "Warten Sie mal...",
                    months: ["Januar", "Februar", "März", "April", "Kann", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
                    weekdays: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
                    shortMonths: ["Jan", "Feb", "Mär", "Apr", "Kan", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
                    rangeSelectorFrom: "Von",
                    rangeSelectorTo: "Zu",
                    rangeSelectorZoom: "Zeitraum",
                    decimalPoint: ".",
                    thousandsSep: ",",
                };
                rangeSelectorButtons = [
                    {
                        type: "month",
                        count: 1,
                        text: "1m",
                    },
                    {
                        type: "month",
                        count: 3,
                        text: "3m",
                    },
                    {
                        type: "month",
                        count: 6,
                        text: "6m",
                    },
                    {
                        type: "ytd",
                        text: "Gestern",
                    },
                    {
                        type: "year",
                        count: 1,
                        text: "1j",
                    },
                    {
                        type: "all",
                        text: "Alles",
                    },
                ];
                xAxisDateFormat = "{value: %m/%d}";
                break;

            default:
                highstockGlobalizedTerms = {
                    loading: "Please, wait...",
                    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                    weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                    shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                    rangeSelectorFrom: "From",
                    rangeSelectorTo: "To",
                    rangeSelectorZoom: "Period",
                    decimalPoint: ".",
                    thousandsSep: ",",
                };
                rangeSelectorButtons = [
                    {
                        type: "month",
                        count: 1,
                        text: "1m",
                    },
                    {
                        type: "month",
                        count: 3,
                        text: "3m",
                    },
                    {
                        type: "month",
                        count: 6,
                        text: "6m",
                    },
                    {
                        type: "ytd",
                        text: "YTD",
                    },
                    {
                        type: "year",
                        count: 1,
                        text: "1y",
                    },
                    {
                        type: "all",
                        text: "All",
                    },
                ];
                xAxisDateFormat = "{value: %m/%d}";
                break;
        }

        // Highstock LANGUAGE
        Highcharts.setOptions({
            lang: highstockGlobalizedTerms,
        });
        // Highstock options
        if (!params.highstockOptions) {
            // Default options
            highstockOptions = {
                chart: {
                    type: chartType,
                    height: chartHeight,
                },
                rangeSelector: {
                    enabled: isSimpleChart ? false : true,
                    inputEnabled: isSimpleChart ? false : true,
                    buttons: rangeSelectorButtons,
                    inputDateFormat: dateFormats[self.LANGUAGE].date,
                    inputEditDateFormat: dateFormats[self.LANGUAGE].edit,
                },
                legend: {
                    enabled: isSimpleChart ? false : true,
                },
                credits: {
                    enabled: false,
                },
                scrollbar: {
                    enabled: isSimpleChart ? false : true,
                },
                xAxis: {
                    ordinal: true,
                    labels: {
                        format: xAxisDateFormat,
                        type: "datetime",
                        style: {
                            color: "#999999",
                            fontSize: "12px",
                        },
                    },
                },
                yAxis: [
                    {
                        labels: {
                            formatter: function () {
                                return (this.value > 0 ? "+" : "") + this.value + "%";
                            },
                            style: {
                                color: "#bbb",
                                fontSize: "11px",
                            },
                            plotLines: [
                                {
                                    value: 0,
                                    width: 2,
                                    color: "#333333",
                                },
                            ],
                        },
                        top: "0%",
                        height: "100%",
                    },
                    {
                        height: "200%",
                    },
                ],

                //},
                navigation: {
                    buttonOptions: {
                        enabled: isSimpleChart ? false : true,
                    },
                },
                exporting: {
                    buttons: {
                        contextButton: {
                            menuItems: ["printChart", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG"],
                        },
                    },
                },
                navigator: {
                    enabled: isSimpleChart ? false : true,
                    handles: {
                        enabled: isSimpleChart ? false : true,
                    },
                    xAxis: {
                        labels: {
                            style: {
                                color: "#999999",
                                fontSize: "14px",
                            },
                        },
                    },
                },
                plotOptions: {
                    series: {
                        compare: "percent",
                        showInNavigator: isSimpleChart ? false : true,
                        stackDistance: 0,
                        dataGrouping: {
                            enabled: false,
                        },
                    },
                    column: {
                        minPointLength: 3,
                    },
                    flags: {
                        accessibility: {
                            exposeAsGroupOnly: true,
                            description: "Flagged.",
                        },
                    },
                },
                tooltip: {
                    formatter: function () {
                        var res =
                            Array.isArray(this.point.options.y) == false
                                ? '<span class="highcharts-color-' + this.series.colorIndex + '">' + Highcharts.dateFormat("%A, %e %B, %Y", new Date(this.x)) + "</span><br/>" + '<span class="highcharts-color-"' + this.series.colorIndex + ">" + this.series.name + "</span>: " + Highcharts.numberFormat(this.y, 2) + " (" + Highcharts.numberFormat(this.point.change, 2) + "%)"
                                : '<span class="highcharts-color-' + this.point.options.color + '">' + Highcharts.dateFormat("%A, %e %B, %Y", new Date(this.point.options.x)) + '</span><br /><span class="highcharts-title">' + this.point.options.type + "</span><br/>• " + this.point.options.y.join("<br />• ");
                        return res;
                    },
                    valueDecimals: 2,
                    split: false,
                },
                // series: undefined // to be load below
            };
        } else {
            // Custom options
            highstockOptions = params.highstockOptions;
        }
    }

    function loadChartData(params) {
        var chartApiUrl =
            self.API_URL +
            "/" +
            self.STOCK_ID +
            "/graphic?" +
            "from=" +
            self.START_DATE.format("YYYY-MM-DD") +
            "&to=" +
            self.END_DATE.format("YYYY-MM-DD") +
            "&tickers=" +
            self.TICKER + // believe, it doesnt matter!
            "&adjusted=" +
            self.ADJUSTED;

        if (self.INDEXES !== undefined) {
            chartApiUrl += "&indexes=" + self.INDEXES;
        }

        $.ajax({
            url: chartApiUrl,
            type: "GET",
            dataType: "json",
            success: function (response) {
                if (response.success) {
                    var filemanager = [];
                    var events = [];

                    if (response.data.activeFilemanager) {
                        lang = self.LANGUAGE === "pt" ? "pt_br" : "en_us";
                        var filesApiUrl = self.API_URL_FILES + "/company/" + response.data.companyId + "/integrations/documents" + "?startDate=" + self.START_DATE.format("YYYY-MM-DD") + "&endDate=" + self.END_DATE.format("YYYY-MM-DD") + "&language=" + lang;
                        var filemanager = JSON.parse(
                            $.ajax({
                                url: filesApiUrl,
                                type: "GET",
                                dataType: "json",
                                success: function (data) {},
                                async: false,
                                error: function (err) {
                                    console.log(err);
                                },
                            }).responseText
                        ).data;
                    }

                    if (response.data.activeEvents) {
                        lang = self.LANGUAGE === "pt" ? "pt-br" : "en-us";
                        var eventsApiUrl = self.API_URL_EVENTS + "/company/" + response.data.companyId + "/integrations/events" + "?startDate=" + self.START_DATE.format("YYYY-MM-DD") + "&endDate=" + self.END_DATE.format("YYYY-MM-DD") + "&language=" + lang;
                        var events = JSON.parse(
                            $.ajax({
                                url: eventsApiUrl,
                                type: "GET",
                                dataType: "json",
                                success: function (data) {},
                                async: false,
                                error: function (err) {
                                    console.log(err);
                                },
                            }).responseText
                        ).data;
                    }

                    if (!isSimpleChart) {
                        renderLiveData(response.data, params, filemanager, events);
                    }

                    renderChart(response, filemanager, events, params); // criar funcao para puxar dados da api de eventos e filemanager

                    $DOCUMENT.querySelector(".loading-content").classList.add("hide");
                }
            },
            error: function (response) {
                console.warn("Não foi possível recuperar os dados do gráfico. Tente novamente ou contate o suporte!");
                console.error("Erro ao recuperar dados da API: ");
                console.warn(response);
            },
        });
    }

    function renderLiveData(data, params, filemanager, events) {
        var live = data.live;
        var timelineActive = data.activeEvents || data.activeFilemanager;
        var line_chart_type_active = highstockOptions.chart.type === "line" ? "active" : "";
        var column_chart_type_active = highstockOptions.chart.type === "column" ? "active" : "";
        var area_chart_type_active = highstockOptions.chart.type === "area" ? "active" : "";

        var texts = {
            pt: {
                max: "Máximo: ",
                min: "Mínimo: ",
                max52: "Máx52: ",
                min52: "Mín52: ",
                open: "Abertura: ",
                vol: "Volume: ",
                title: "Títulos: ",
                business: "Negócios: ",
                update: "Última atualização: ",
                line: "Linha",
                bar: "Barra",
                area: "Área",
                month: "mês",
                months: "meses",
                year: "ano",
                years: "anos",
                source: "Fonte: ",
                files: "Arquivamentos",
                events: "Eventos",
                timeline: "Linha do tempo",
                view: "Visualizar informações",
                noinfos: "Não há informações no período selecionado.",
            },
            "pt-br": {
                max: "Máximo: ",
                min: "Mínimo: ",
                max52: "Máx52: ",
                min52: "Mín52: ",
                open: "Abertura: ",
                vol: "Volume: ",
                title: "Títulos: ",
                business: "Negócios: ",
                update: "Última atualização: ",
                line: "Linha",
                bar: "Barra",
                area: "Área",
                month: "mês",
                months: "meses",
                year: "ano",
                years: "anos",
                source: "Fonte: ",
                files: "Arquivamentos",
                events: "Eventos",
                timeline: "Linha do tempo",
                view: "Visualizar informações",
                noinfos: "Não há informações no período selecionado.",
            },
            es: {
                max: "Máximo: ",
                min: "Mínimo: ",
                max52: "Máx52: ",
                min52: "Mín52: ",
                open: "Apertura: ",
                vol: "Volumen: ",
                title: "Titulos: ",
                business: "Negocios: ",
                update: "Última atualización: ",
                line: "Linea",
                bar: "Barra",
                area: "Area",
                month: "mes",
                months: "meses",
                year: "año",
                years: "años",
                source: "Fuente: ",
                files: "Limaduras",
                events: "Eventos",
                timeline: "línea de tiempo",
                view: "Ver información",
                noinfos: "No hay información para el período seleccionado.",
            },
            "es-es": {
                max: "Máximo: ",
                min: "Mínimo: ",
                max52: "Máx52: ",
                min52: "Mín52: ",
                open: "Apertura: ",
                vol: "Volumen: ",
                title: "Titulos: ",
                business: "Negocios: ",
                update: "Última atualización: ",
                line: "Linea",
                bar: "Barra",
                area: "Area",
                month: "mes",
                months: "meses",
                year: "año",
                years: "años",
                source: "Fuente: ",
                files: "Limaduras",
                events: "Eventos",
                timeline: "línea de tiempo",
                view: "Ver información",
                noinfos: "No hay información para el período seleccionado.",
            },
            en: {
                max: "Maximum: ",
                min: "Minimal: ",
                max52: "Max52: ",
                min52: "Min52: ",
                open: "Open: ",
                vol: "Volume: ",
                title: "Shares: ",
                business: "Trades: ",
                update: "Last update: ",
                line: "Line",
                bar: "Bar",
                area: "Area",
                month: "month",
                months: "months",
                year: "year",
                years: "years",
                source: "Source: ",
                files: "Filings",
                events: "Events",
                timeline: "Timeline",
                view: "View information",
                noinfos: "There is no information for the selected period.",
            },
            "zh-hant": {
                max: "最大限度: ",
                min: "最低限度: ",
                max52: "最多52: ",
                min52: "最低52: ",
                open: "開場: ",
                vol: "體積: ",
                title: "職稱: ",
                business: "商業: ",
                update: "最後更新: ",
                line: "線",
                bar: "酒吧",
                area: "區域",
                month: "月",
                months: "月",
                year: "年",
                years: "歲",
                source: "來源: ",
                files: "Filings",
                events: "Events",
                timeline: "Timeline",
                view: "View information",
                noinfos: "There is no information for the selected period.",
            },
            "zh-hans": {
                max: "最大限度: ",
                min: "最低限度: ",
                max52: "最多52: ",
                min52: "最低52: ",
                open: "开场: ",
                vol: "体积: ",
                title: "职称: ",
                business: "商业: ",
                update: "最后更新: ",
                line: "线",
                bar: "酒吧",
                area: "区域",
                month: "月",
                months: "月",
                year: "年",
                years: "岁",
                source: "来源: ",
                files: "Filings",
                events: "Events",
                timeline: "Timeline",
                view: "View information",
                noinfos: "There is no information for the selected period.",
            },
            fr: {
                max: "Maximum: ",
                min: "Minimal: ",
                max52: "Max52: ",
                min52: "Min52: ",
                open: "Ouvert: ",
                vol: "Le volume: ",
                title: "Actions: ",
                business: "Métiers: ",
                update: "Dernière mise à jour: ",
                line: "Ligne",
                bar: "Bar",
                area: "Surface",
                month: "mois",
                months: "mois",
                year: "an",
                years: "années",
                source: "La source: ",
                files: "Filings",
                events: "Events",
                timeline: "Timeline",
                view: "View information",
                noinfos: "There is no information for the selected period.",
            },
            de: {
                max: "Maximum: ",
                min: "Minimal: ",
                max52: "Max52: ",
                min52: "Min52: ",
                open: "Öffnen: ",
                vol: "Volumen: ",
                title: "Anteile: ",
                business: "Trades: ",
                update: "Letztes Update: ",
                line: "Linie",
                bar: "Bar",
                area: "Bereich",
                month: "Monat",
                months: "Monate",
                year: "Jahr",
                years: "Jahre",
                source: "Quelle: ",
                files: "Filings",
                events: "Events",
                timeline: "Timeline",
                view: "View information",
                noinfos: "There is no information for the selected period.",
            },
        };

        var arrayTimeline = filemanager.map(function(file) {
            return {
              x: file.date,
              title: " ",
              link: JSON.parse(file.link),
              type: texts[self.LANGUAGE].files,
              y: JSON.parse(file.infos.replace("\t", ""))
            };
          }).concat(
            events.map(function(event) {
              return {
                x: event.date,
                title: " ",
                link: JSON.parse(event.link),
                type: texts[self.LANGUAGE].events,
                y: JSON.parse(event.infos.replace("\t", ""))
              };
            })
          );
        var chartTemplateMain = !timelineActive ? '<div class="stockinfo-chart-area">' : '<div class="stockinfo-chart-timeline-area">';

        var chartTemplateTimeline = !timelineActive
            ? ""
            : '<div class="timelineChart">' +
              '<header class="timelineChartHeaderArea">' +
              '<h1 class="timelineChartHeader">' +
              texts[self.LANGUAGE].timeline +
              "</h1>" +
              '<div class="timelineChartHeaderInformations">' +
              '<div class="timelineChartHeaderInformationsTitle">' +
              texts[self.LANGUAGE].view +
              "</div>" +
              '<div class="timelineChartHeaderInformationsTitle">' +
              '<span class="timelineChartHeaderInformationsChangeColor">Data: </span><span class="time-start-date">-</span>' +
              '<span class="timelineChartHeaderInformationsChangeColor"> at </span><span class="time-final-date">-</span>' +
              "</div>" +
              "</div>" +
              "</header>" +
              '<main class="filesArea">' +
              '<ul class="listFiles"></ul>' +
              "</main>" +
              "</div>";

        var chartTemplate =
            '<div id="chart-stockinfo" class="chart">' +
            '<div class="loading-content">' +
            '<div class="loading"></div>' +
            "</div>" +
            chartTemplateMain +
            '<div class="col-tableChart">' +
            '<div id="tableChart">' +
            '<ul class="tbPrices">' +
            '<li class="tbPrices__title">' +
            '<span class="ticker">-</span>' +
            '<div class="dateReference">' +
            texts[self.LANGUAGE].update +
            '<span class="last-date">-</span>' +
            "</div>" +
            "</li>" +
            '<li class="tbPrices__price">' +
            '<span class="preco">' +
            '<span class="price">-</span>' +
            "<br>" +
            '<span class="variation">' +
            '<span class="parenthesis">(</span> <span class="vari">-</span> <span class="parenthesis">)</span>' +
            "</span>" +
            "</span>" +
            "</li>" +
            '<li class="tbPrices__column">' +
            '<div class="tbPrices__column-box first">' +
            '<span class="label">' +
            texts[self.LANGUAGE].max +
            "</span>" +
            '<span class="maxima value"><span class="max">-</span></span>' +
            "</div>" +
            '<div class="tbPrices__column-box">' +
            '<span class="label">' +
            texts[self.LANGUAGE].min +
            "</span>" +
            '<span class="minima value"><span class="min">-</span></span>' +
            "</div>" +
            "</li>" +
            '<li class="tbPrices__column">' +
            '<div class="tbPrices__column-box first">' +
            '<span class="label">' +
            texts[self.LANGUAGE].open +
            "</span>" +
            '<span class="value down"><span class="open">-</span></span>' +
            "</div>" +
            '<div class="tbPrices__column-box">' +
            '<span class="label">' +
            texts[self.LANGUAGE].vol +
            "</span>" +
            '<span class="value"><span class="vol">-</span></span>' +
            "<div>" +
            "</li>" +
            '<li class="tbPrices__column">' +
            '<div class="tbPrices__column-box first">' +
            '<span class="label">' +
            texts[self.LANGUAGE].max52 +
            "</span>" +
            '<span class="value down"><span class="max52">-</span></span>' +
            "</div>" +
            '<div class="tbPrices__column-box">' +
            '<span class="label">' +
            texts[self.LANGUAGE].min52 +
            "</span>" +
            '<span class="value down"><span class="min52">-</span></span>' +
            "<div>" +
            "</li>" +
            '<li class="tbPrices__column">' +
            '<div class="tbPrices__column-box first">' +
            '<span class="label">' +
            texts[self.LANGUAGE].business +
            "</span>" +
            '<span class="value"><span class="trade">-</span></span>' +
            "</div>" +
            '<div class="tbPrices__column-box">' +
            '<span class="label">' +
            texts[self.LANGUAGE].title +
            "</span>" +
            '<span class="value"><span class="share">-</span></span>' +
            "<div>" +
            "</li>" +
            "</ul>" +
            "</div>" +
            '<div id="container-chart" style="width: 100%"></div>' +
            '<div class="btns hide">' +
            '<input type="button" id="chart-type-line" data-chart-type="line" class="btn-change-chart-type ' +
            line_chart_type_active +
            '" value="' +
            texts[self.LANGUAGE].line +
            '" />' +
            '<input type="button" id="chart-type-column" data-chart-type="column" class="btn-change-chart-type ' +
            column_chart_type_active +
            '" value="' +
            texts[self.LANGUAGE].bar +
            '" />' +
            '<input type="button" id="chart-type-area" data-chart-type="area" class="btn-change-chart-type ' +
            area_chart_type_active +
            '" value="' +
            texts[self.LANGUAGE].area +
            '" style="margin-right: 50px" />' +
            '<input type="button" id="btn-period-1m" data-chart-period="1m" class="btn-change-chart-period active" value="1 ' +
            texts[self.LANGUAGE].month +
            '" />' +
            '<input type="button" id="btn-period-6m" data-chart-period="6m" class="btn-change-chart-period" value="6 ' +
            texts[self.LANGUAGE].months +
            '" />' +
            '<input type="button" id="btn-period-1y" data-chart-period="1y" class="btn-change-chart-period" value="1 ' +
            texts[self.LANGUAGE].year +
            '" />' +
            '<input type="button" id="btn-period-3y" data-chart-period="3y" class="btn-change-chart-period" value="3 ' +
            texts[self.LANGUAGE].years +
            '" />' +
            '<input type="button" id="btn-period-5y" data-chart-period="5y" class="btn-change-chart-period" value="5 ' +
            texts[self.LANGUAGE].years +
            '" />' +
            "</div>" +
            '<div class="table-footer">' +
            '<div class="footer">' +
            texts[self.LANGUAGE].source +
            '<span class="link">' +
            '<a target="_blank" id="sourceLink"></a>' +
            "</span>" +
            "</div>" +
            "</div>" +
            "</div>" +
            chartTemplateTimeline +
            "</div>";

        $(self.rootElement).append(chartTemplate);

        var stock = undefined;
        var table = $DOCUMENT.querySelector("#tableChart");

        if (live.tickers.length > 0) {
            stock = live.tickers[0];
        } else if (live.indexes.length > 0) {
            stock = live.indexes[0];
        }

        if (!!params.tickers && params.tickers.indexOf(",") == -1) {
            stock = live.tickers.filter(function (item) {
                return item.ticker === params.tickers;
            })[0];
        }

        if (!stock) return;

        var variation_class = "down";
        var plus_symbol_variation = "";

        if (stock.info.var > 0) {
            variation_class = "up";
            plus_symbol_variation = "+";
        }
        if (stock.info.var === 0) {
            variation_class = "neutro";
        }

        var variation = formatCurrency(stock.info.var);
        if (variation !== "-") {
            variation = plus_symbol_variation + variation + " %";
        }

        table.querySelector(".variation").classList.add(variation_class);
        table.querySelector(".ticker").innerHTML = stock.ticker;
        table.querySelector(".last-date").innerHTML = getLastUpdateDate([stock]);
        table.querySelector(".price").innerHTML = formatCurrency(stock.info.price, true);
        table.querySelector(".vari").innerHTML = variation;
        table.querySelector(".max").innerHTML = formatCurrency(stock.info.high, true);
        table.querySelector(".min").innerHTML = formatCurrency(stock.info.low, true);
        table.querySelector(".open").innerHTML = formatCurrency(stock.info.open, true);
        table.querySelector(".vol").innerHTML = self.HAS_SHORT_MODE === true ? convertToShortMode(stock.info.vol) : formatNumber(stock.info.vol, false);
        table.querySelector(".max52").innerHTML = formatCurrency(stock.info.max52, true);
        table.querySelector(".min52").innerHTML = formatCurrency(stock.info.min52, true);
        table.querySelector(".trade").innerHTML = self.HAS_SHORT_MODE === true ? convertToShortMode(stock.info.trade) : formatNumber(stock.info.trade, false);
        table.querySelector(".share").innerHTML = self.HAS_SHORT_MODE === true ? convertToShortMode(stock.info.share) : formatNumber(stock.info.share, false);

        var arrayTimelineHtml = undefined;
        if (timelineActive) {
            var arrayTimelineOrder = arrayTimeline.sort(function (a, b) {
                return new Date(b.x).getTime() - new Date(a.x).getTime();
            });

            if (arrayTimeline.length > 0) {
                arrayTimelineHtml = arrayTimelineOrder
                    .map(function(item) {
                        return item.y
                            .map(function(info, index) {
                                var svgIcon =
                                    item.type == texts[self.LANGUAGE].events
                                        ? `<svg class="listFilesimage" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 5.2851L1 5.2851" stroke="#8D9DB9" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M10.4287 1.00025L10.4287 3.22845" stroke="#8D9DB9" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M3.74316 1L3.74316 3.22821" stroke="#8D9DB9" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M1 4.4115L1 10.876C1 12.049 1.9086 13 3.02941 13H10.9706C12.0914 13 13 12.049 13 10.876V4.4115C13 3.23842 12.0914 2.28746 10.9706 2.28746H3.02941C1.9086 2.28746 1 3.23842 1 4.4115Z" stroke="#8D9DB9" stroke-width="0.75"/>
              <path d="M8.71436 9.22318V10.7747C8.71436 11.0562 8.90906 11.2844 9.14923 11.2844H10.8509C11.0911 11.2844 11.2858 11.0562 11.2858 10.7747V9.22318C11.2858 8.94165 11.0911 8.71341 10.8509 8.71341H9.14923C8.90906 8.71341 8.71436 8.94165 8.71436 9.22318Z" fill="#8D9DB9"/>
              </svg>`
                                        : `<svg class="listFilesimage" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3 4.5C3 4.22386 3.17673 4 3.39474 4H7.60526C7.82327 4 8 4.22386 8 4.5C8 4.77614 7.82327 5 7.60526 5H3.39474C3.17673 5 3 4.77614 3 4.5Z" fill="#8D9DB9"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3 6.5C3 6.22386 3.17673 6 3.39474 6H7.60526C7.82327 6 8 6.22386 8 6.5C8 6.77614 7.82327 7 7.60526 7H3.39474C3.17673 7 3 6.77614 3 6.5Z" fill="#8D9DB9"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3 8.5C3 8.22386 3.17673 8 3.39474 8H7.60526C7.82327 8 8 8.22386 8 8.5C8 8.77614 7.82327 9 7.60526 9H3.39474C3.17673 9 3 8.77614 3 8.5Z" fill="#8D9DB9"/>
                <path d="M9.625 5.45238C9.625 5.65949 9.79289 5.82738 10 5.82738C10.2071 5.82738 10.375 5.65949 10.375 5.45238H9.625ZM7 12.375C7.20711 12.375 7.375 12.2071 7.375 12C7.375 11.7929 7.20711 11.625 7 11.625V12.375ZM3 1.375H8V0.625H3V1.375ZM1.375 10V3H0.625V10H1.375ZM9.625 3V5.45238H10.375V3H9.625ZM3 12.375H7V11.625H3V12.375ZM0.625 10C0.625 11.3117 1.68832 12.375 3 12.375V11.625C2.10254 11.625 1.375 10.8975 1.375 10H0.625ZM8 1.375C8.89746 1.375 9.625 2.10254 9.625 3H10.375C10.375 1.68832 9.31168 0.625 8 0.625V1.375ZM3 0.625C1.68832 0.625 0.625 1.68832 0.625 3H1.375C1.375 2.10254 2.10254 1.375 3 1.375V0.625Z" fill="#8D9DB9"/>
                <path d="M10.6737 8.5C10.6737 8.29289 10.5058 8.125 10.2987 8.125C10.0916 8.125 9.9237 8.29289 9.9237 8.5H10.6737ZM13.375 9.5C13.375 9.29289 13.2071 9.125 13 9.125C12.7929 9.125 12.625 9.29289 12.625 9.5H13.375ZM9.9237 8.5V11.0783H10.6737V8.5H9.9237ZM12.2321 11.0783V8.42857H11.4821V11.0783H12.2321ZM8.625 8.42857V11H9.375V8.42857H8.625ZM11.0001 13.375H11.8571V12.625H11.0001V13.375ZM13.375 11.8571V9.5H12.625V11.8571H13.375ZM11.8571 13.375C12.6954 13.375 13.375 12.6954 13.375 11.8571H12.625C12.625 12.2812 12.2812 12.625 11.8571 12.625V13.375ZM8.625 11C8.625 12.3117 9.68839 13.375 11.0001 13.375V12.625C10.1026 12.625 9.375 11.8974 9.375 11H8.625ZM10.4286 6.625C9.43249 6.625 8.625 7.43249 8.625 8.42857H9.375C9.375 7.8467 9.8467 7.375 10.4286 7.375V6.625ZM12.2321 8.42857C12.2321 7.43249 11.4247 6.625 10.4286 6.625V7.375C11.0104 7.375 11.4821 7.8467 11.4821 8.42857H12.2321ZM11.0779 12.2325C11.7154 12.2325 12.2321 11.7158 12.2321 11.0783H11.4821C11.4821 11.3016 11.3012 11.4825 11.0779 11.4825V12.2325ZM9.9237 11.0783C9.9237 11.7158 10.4405 12.2325 11.0779 12.2325V11.4825C10.8547 11.4825 10.6737 11.3016 10.6737 11.0783H9.9237Z" fill="#8D9DB9"/>
                </svg>`;

                                return `<li class="listFilesArea ${item.type.toLowerCase()}">
              <div class="listFileItems">
                <div class="listFilesimageArea">${svgIcon}</div>
                <p class="listFileDate">${formatDate(item.x, "{0} {1}")}</p>
              </div>
              <div class="listFileItemsInfo">
                <p class="listFileArchiveName">${item.type}</p>
                ${
                    item.type == texts[self.LANGUAGE].events
                        ? `<p class="listFileArchiveFile" title="${info}">
                      ${!item.link ? '<span class="event">' + info + "</span></p>" : '<a href="' + item.link[index] + '" target="_blank">' + info + "</a>"}` //eventos
                        : `<p class="listFileArchiveFile" title="${info}"><a href="${item.link[index]}" target="_blank">${info}</a></p>` //arquivos
                }
              </div>
            </li>`;
                            })
                            .join("");
                    })
                    .join("");
            } else {
                arrayTimelineHtml = '<li class="listFilesArea no-infos">' + '<div class="listFileItemsInfo">' + '<p class="listFileArchiveName" style="text-align: center;font-size: 13px;">' + texts[self.LANGUAGE].noinfos + "</p>" + "</div>" + "</li>";
            }

            var tableList = $DOCUMENT.querySelector(".timelineChart");
            tableList.querySelector(".listFiles").innerHTML = arrayTimelineHtml;
            tableList.querySelector(".time-start-date").innerHTML = formatDate(self.START_DATE, "{1} {0}, {2}");
            tableList.querySelector(".time-final-date").innerHTML = formatDate(self.END_DATE, "{1} {0}, {2}");
        }

        $(".btn-change-chart-type").on("click", function (e) {
            changeChartType($(e.target).data("chart-type"));
        });

        $(".btn-change-chart-period").on("click", function (e) {
            changeChartPeriod($(e.target).data("chart-period"), params);
        });
    }

    function renderChart(response, filemanager, events, params) {
        var history = response.data.history;
        var stocksData = [];
        var isFirst = true;
        var tickerCount = -1;

        var texts = {
            pt: {
                max: "Máximo: ",
                min: "Mínimo: ",
                open: "Abertura: ",
                vol: "Volume: ",
                files: "Arquivamentos",
                events: "Eventos",
            },
            "pt-br": {
                max: "Máximo: ",
                min: "Mínimo: ",
                open: "Abertura: ",
                vol: "Volume: ",
                files: "Arquivamentos",
                events: "Eventos",
            },
            es: {
                max: "Máximo: ",
                min: "Mínimo: ",
                open: "Apertura: ",
                vol: "Volumen: ",
                files: "Limaduras",
                events: "Eventos",
            },
            "es-es": {
                max: "Máximo: ",
                min: "Mínimo: ",
                open: "Apertura: ",
                vol: "Volumen: ",
                files: "Limaduras",
                events: "Eventos",
            },
            en: {
                max: "Maximum: ",
                min: "Minimal: ",
                open: "Open: ",
                vol: "Close: ",
                files: "Filings",
                events: "Events",
            },
            "zh-hant": {
                max: "最大限度: ",
                min: "最低限度: ",
                open: "開場: ",
                vol: "體積: ",
                files: "Filings",
                events: "Events",
            },
            "zh-hans": {
                max: "最大限度: ",
                min: "最低限度: ",
                open: "开场: ",
                vol: "体积: ",
                files: "Filings",
                events: "Events",
            },
            fr: {
                max: "Maximum: ",
                min: "Minimal: ",
                open: "Ouvert: ",
                vol: "Fermer: ",
                files: "Filings",
                events: "Events",
            },
            de: {
                max: "Maximum: ",
                min: "Minimal: ",
                open: "Öffnen: ",
                vol: "Schließen: ",
                files: "Filings",
                events: "Events",
            },
        };

        var chartTemplate =
            '<div id="chart-stockinfo" class="chart">' +
            '<div class="loading-content">' + //INICIO
            '<div class="loading"></div>' +
            "</div>" + // FIM
            '<div id="tableTimeline">' + // INICIO
            '<ul class="tbTimeline simple-chart"></ul>' +
            "</div>" + // FIM
            '<div id="tableChart">' + // INICIO
            '<ul class="tbPrices simple-chart">' +
            '<li class="tbPrices__title">' +
            '<span class="ticker">-</span>' +
            '<div class="dateReference">' +
            'Última atualização: <span class="last-date">-</span>' +
            "</div>" +
            "</li>" +
            '<li class="tbPrices__price">' +
            '<span class="preco">' +
            '<span class="price">-</span>' +
            "<br>" +
            '<span class="variation down">' +
            '<span class="parenthesis">(</span><span class="vari">-</span>%<span class="parenthesis">)</span>' +
            "</span>" +
            "</span>" +
            "</li>" +
            '<li class="tbPrices__column">' +
            '<div class="tbPrices__column-box first">' +
            '<span class="label">Máximo: </span>' +
            '<span class="maxima value"><span class="max">-</span></span>' +
            "</div>" +
            '<div class="tbPrices__column-box">' +
            '<span class="label">Mínimo: </span>' +
            '<span class="minima value"><span class="min">-</span></span>' +
            "</div>" +
            "</li>" +
            '<li class="tbPrices__column">' +
            '<div class="tbPrices__column-box first">' +
            '<span class="label">Abertura: </span>' +
            '<span class="value down"><span class="open">-</span></span>' +
            "</div>" +
            '<div class="tbPrices__column-box">' +
            '<span class="label">Volume: </span>' +
            '<span class="value"><span class="vol">-</span></span>' +
            "<div>" +
            "</li>" +
            '<li class="tbPrices__column">' +
            '<div class="tbPrices__column-box first">' +
            '<span class="label">' +
            texts[self.LANGUAGE].max52 +
            ": </span>" +
            '<span class="value down"><span class="max52">-</span></span>' +
            "</div>" +
            '<div class="tbPrices__column-box">' +
            '<span class="label">' +
            texts[self.LANGUAGE].min52 +
            ": </span>" +
            '<span class="value down"><span class="min52">-</span></span>' +
            "<div>" +
            "</li>" +
            '<li class="tbPrices__column">' +
            '<div class="tbPrices__column-box first">' +
            '<span class="label">Negócios: </span>' +
            '<span class="value"><span class="trade">-</span></span>' +
            "</div>" +
            '<div class="tbPrices__column-box">' +
            '<span class="label">Títulos: </span>' +
            '<span class="value"><span class="share">-</span></span>' +
            "<div>" +
            "</li>" +
            "</ul>" +
            "</div>" + // FIM
            '<div id="container-chart" style="width: 100%"></div>' + // INICIO
            '<div class="btns hide simple-chart">' +
            '<input type="button" id="chart-type-line" class="btn-change-chart-type active" value="Linha" onclick="changeChartType("line")" />' +
            '<input type="button" id="chart-type-column" class="btn-change-chart-type" value="Barra" onclick="changeChartType("column")" />' +
            '<input type="button" id="chart-type-area" class="btn-change-chart-type" value="Área" onclick="changeChartType("area")" style="margin-right: 50px" />' +
            '<input type="button" id="btn-period-1m" class="btn-change-chart-period active" value="1 mês" onclick="changeChartPeriod("1m")" />' +
            '<input type="button" id="btn-period-6m" class="btn-change-chart-period" value="6 meses" onclick="changeChartPeriod("6m")" />' +
            '<input type="button" id="btn-period-1y" class="btn-change-chart-period" value="1 ano" onclick="changeChartPeriod("1y")" />' +
            '<input type="button" id="btn-period-3y" class="btn-change-chart-period" value="3 anos" onclick="changeChartPeriod("3y")" />' +
            '<input type="button" id="btn-period-5y" class="btn-change-chart-period" value="5 anos" onclick="changeChartPeriod("5y")" />' +
            "</div>" + // FIM
            '<div class="table-footer">' + // INICIO
            '<div class="footer">' +
            "Fonte: " +
            '<span class="link">' +
            '<a target="_blank" id="sourceLink"></a>' +
            "</span>" +
            "</div>" +
            "</div>" + // FIM
            "</div>";

        $(self.rootElement).append(chartTemplate);

        var mappedTickers = history.tickers.map(function (ticker) {
            var tickerHistory = ticker.history.map(function (stockinfo) {
                return [Number(moment.utc(stockinfo.date, "YYYY-MM-DD").format("x")), Number(stockinfo.closed)];
            });

            tickerHistory = tickerHistory.reverse();

            var result = {
                name: ticker.ticker,
                data: tickerHistory,
                id: isFirst ? "dataseries" : "", // apenas o primeiro ticker
                visible: params.visibleAllTickers ? true : isFirst ? true : false,
                currencySymbol: self.CURRENCY_SYMBOL,
            };

            isFirst = false;
            tickerCount += 1;
            return result;
        });

        var mappedIndexes = history.indexes.map(function (index) {
            var indexHistory = index.history.map(function (stockinfo) {
                return [Number(moment.utc(stockinfo.date, "YYYY-MM-DD").format("x")), Number(stockinfo.closed)];
            });
            indexHistory = indexHistory.reverse();

            if (index.ticker === "ECDICT") {
                var nameTicker = "CDI";
            } else if (index.ticker === "EUSCOM") {
                var nameTicker = "Dólar Comercial";
            } else if (index.ticker === "ISEE") {
                var nameTicker = "ISE";
            } else {
                var nameTicker = index.ticker;
            }

            var result = {
                name: nameTicker,
                data: indexHistory,
                visible: params.visibleAllIndex ? true : isFirst ? true : false,
                currencySymbol: "",
            };

            isFirst = false;
            tickerCount += 1;
            return result;
        });

        var mappedFiles = [
            {
              name: texts[self.LANGUAGE].files,
              type: "flags",
              allowOverlapX: true,
              data: filemanager.map(function(file) {
                return {
                  x: new Date(file.date).getTime(),
                  title: " ",
                  type: texts[self.LANGUAGE].files,
                  y: JSON.parse(file.infos.replace("\t", ""))
                };
              }),
              //onSeries: 'dataseries',
              yAxis: 1,
              shape: "circlepin",
              visible: true,
              stackDistance: 0,
              width: 3,
              height: 3,
              color: "#008000",
              fillColor: "#008000",
              style: {
                color: "#008000"
              },
              states: {
                hover: {
                  color: "#008000",
                  fillColor: "#008000",
                  style: {
                    color: "#008000"
                  }
                }
              }
            }
          ];

          var mappedEvents = [
            {
              name: texts[self.LANGUAGE].events,
              type: "flags",
              allowOverlapX: true,
              data: events.map(function(event) {
                return {
                  x: new Date(event.date).getTime(),
                  title: " ",
                  type: texts[self.LANGUAGE].events,
                  y: JSON.parse(event.infos.replace("\t", ""))
                };
              }),
              //onSeries: 'dataseries',
              yAxis: 1,
              shape: "circlepin",
              visible: true,
              stackDistance: 0,
              width: 3,
              height: 3,
              color: "#FF8C00",
              fillColor: "#FF8C00",
              style: {
                color: "#FF8C00"
              },
              states: {
                hover: {
                  color: "#FF8C00",
                  fillColor: "#FF8C00",
                  style: {
                    color: "#FF8C00"
                  }
                }
              }
            }
          ];
          

        [].push.apply(stocksData, mappedTickers);
        self.INDEXES !== undefined && [].push.apply(stocksData, mappedIndexes);

        if (filemanager.length > 0) {
            [].push.apply(stocksData, mappedFiles);
        }
        if (events.length > 0) {
            [].push.apply(stocksData, mappedEvents);
        }

        // Chart colors
        for (var i = 0; i < tickerCount; i++) {
            if (chartColors.length >= i + 1) {
                stocksData[i].color = chartColors[i];
            }
        }

        highstockOptions.series = stocksData;
        Highcharts.stockChart("container-chart", highstockOptions);

        var sourceLink = $DOCUMENT.querySelector("#sourceLink");

        sourceLink.innerHTML = history.source;
        sourceLink.href = history.link;

        $(self.rootElement)
            .find(".chart")
            .each(function (chartId, item) {
                if (chartId !== 0) {
                    $(item).remove();
                }
            });

        if (filemanager.length > 0) {
            tickerCount += 1;
            $(".highcharts-series-" + tickerCount).on("click", function (e) {
                if ($(".listFilesArea.arquivamentos").css("display") == "none") {
                    $(".listFilesArea.arquivamentos").show();
                } else {
                    $(".listFilesArea.arquivamentos").hide();
                }
            });
        }

        if (events.length > 0) {
            tickerCount += 1;
            $(".highcharts-series-" + tickerCount).on("click", function (e) {
                if ($(".listFilesArea.eventos").css("display") == "none") {
                    $(".listFilesArea.eventos").show();
                } else {
                    $(".listFilesArea.eventos").hide();
                }
            });
        }

        chartPeriodStyle(self.CHART_PERIOD);
    }

    function changeChartType(chartType) {
        $DOCUMENT.querySelector("#chart-type-line").classList.remove("active");
        $DOCUMENT.querySelector("#chart-type-column").classList.remove("active");
        $DOCUMENT.querySelector("#chart-type-area").classList.remove("active");

        var chartTypeStrategy = {
            line: function () {
                $DOCUMENT.querySelector("#chart-type-line").classList.add("active");
            },
            column: function () {
                $DOCUMENT.querySelector("#chart-type-column").classList.add("active");
            },
            area: function () {
                $DOCUMENT.querySelector("#chart-type-area").classList.add("active");
            },
        };

        chartTypeStrategy[chartType]();

        highstockOptions.chart.type = chartType;
        var elementRender = $(self.rootElement).find("#container-chart");
        Highcharts.stockChart("container-chart", highstockOptions);
    }

    function changeChartPeriod(period, params) {
        self.END_DATE = moment();

        var chartPeriodStrategy = {
            "1m": function () {
                self.START_DATE = moment().subtract(1, "months");
                self.CHART_PERIOD = "1m";
            },
            "6m": function () {
                self.START_DATE = moment().subtract(6, "months");
                self.CHART_PERIOD = "6m";
            },
            "1y": function () {
                self.START_DATE = moment().subtract(1, "years");
                self.CHART_PERIOD = "1y";
            },
            "3y": function () {
                self.START_DATE = moment().subtract(3, "years");
                self.CHART_PERIOD = "3y";
            },
            "5y": function () {
                self.START_DATE = moment().subtract(5, "years");
                self.CHART_PERIOD = "5y";
            },
        };

        chartPeriodStrategy[period]();
        chartPeriodStyle(period);
        loadChartData(params);
    }

    function chartPeriodStyle(period) {
        $DOCUMENT.querySelector(".loading-content").classList.remove("hide");
        $DOCUMENT.querySelector("#btn-period-1m").classList.remove("active");
        $DOCUMENT.querySelector("#btn-period-6m").classList.remove("active");
        $DOCUMENT.querySelector("#btn-period-1y").classList.remove("active");
        $DOCUMENT.querySelector("#btn-period-3y").classList.remove("active");
        $DOCUMENT.querySelector("#btn-period-5y").classList.remove("active");

        var chartPeriodStrategy = {
            "1m": function () {
                $DOCUMENT.querySelector("#btn-period-1m").classList.add("active");
            },
            "6m": function () {
                $DOCUMENT.querySelector("#btn-period-6m").classList.add("active");
            },
            "1y": function () {
                $DOCUMENT.querySelector("#btn-period-1y").classList.add("active");
            },
            "3y": function () {
                $DOCUMENT.querySelector("#btn-period-3y").classList.add("active");
            },
            "5y": function () {
                $DOCUMENT.querySelector("#btn-period-5y").classList.add("active");
            },
        };

        chartPeriodStrategy[period]();
    }
}
